/* ═══════════════════════════════════════════════════════════
   Käännösavainten kontekstit englanniksi (Toni 11.10.2026 «Lähdekieli valittavaksi… Ei Gintaras osaa suomea… EN pakollinen»).

   Avain = kaannokset.ts:n suomenkielinen konteksti (k), arvo = sama englanniksi. Käännösten tarkistus näyttää tämän, kun
   lähdekieleksi on valittu englanti — tarkistaja joka ei osaa suomea tietää silloin, missä teksti näkyy. Sama konteksti
   kattaa kaikki avaimet joilla se on. deploy/kaannosportti.mjs (kommitoi.sh) pysäyttää commitin, jos kontekstilta puuttuu
   rivi täältä. Konekäännös 11.10.2026, lukitun sanaston mukaan (kohde = project, kenttätili = field account …).
   ═══════════════════════════════════════════════════════════ */

export const KONTEKSTI_EN: Record<string, string> = {
  "hitsilistan hitsinumeron viereen: numero on paikanpitäjä tai sama kuin linjan numero": "Next to the weld number in the weld list: the number is a placeholder or equals the line number",
  "vihje hitsinumeron varoituksen päällä": "Tooltip on the weld-number warning",
  "kirjautumissivun otsikko kenttätilin tilassa": "sign-in page heading in field-account mode",
  "kirjautumislomakkeen kenttä": "sign-in form field",
  "kenttätilin kirjautumiskenttä: henkilön oma koodi": "field-account sign-in field: the person's own code",
  "koodikentän esimerkkiteksti": "code field placeholder text",
  "kenttätilin kirjautumiskenttä": "field-account sign-in field",
  "kirjautumisnappi": "sign-in button",
  "kirjautumisnappi lähetyksen aikana": "sign-in button while submitting",
  "linkki kenttätilin kirjautumiseen": "link to field-account sign-in",
  "linkki takaisin sähköpostikirjautumiseen": "link back to email sign-in",
  "linkki kirjautumissivulla salasanan palautukseen": "link on the sign-in page to password reset",
  "palautuslomakkeen otsikko": "reset form heading",
  "palautuslomakkeen ohje": "reset form instructions",
  "nappi: lähetä palautuslinkki": "button: send reset link",
  "vahvistus: sama vastaus osoitteesta riippumatta": "confirmation: same response regardless of the address",
  "virhe kun palvelin ei vastaa": "error when the server does not respond",
  "kellonajan edessä päiväyksen jälkeen: «7.10.2026 klo 14:05»": "before the time, after the date: «7.10.2026 klo 14:05»",
  "kirjautumissivu: istunto vanheni kesken käytön (ei omaa uloskirjautumista)": "sign-in page: session expired during use (not the user's own sign-out)",
  "kielivalitsimen otsikko (kirjautumissivu ja Omat tiedot)": "language selector heading (sign-in page and My details)",
  "kielivalinta: käytä organisaation oletuskieltä": "language option: use the organisation's default language",
  "ilmoitus kun kieli on vaihdettu": "notice when the language has been changed",
  "Omat tiedot: mitä kieli koskee": "My details: what the language setting applies to",
  "valikon ryhmä (tarkastajan tunnus)": "menu group (inspector account)",
  "valikon ryhmä (kenttätili)": "menu group (field account)",
  "valikon ryhmä": "menu group",
  "valikon ryhmä: henkilöstö ja kalusto": "menu group: personnel and equipment",
  "valikon kohta: koulutus": "menu item: training",
  "valikon kohta": "menu item",
  "valikon kohta: linjatarkastusten seuranta": "menu item: line inspection tracking",
  "valikon kohta: valmiina koeponnistukseen": "menu item: ready for pressure test",
  "seurantanäkymä": "tracking view",
  "valikon kohta: hitsauksen etenemä": "menu item: welding progress",
  "valikon kohta: ilmanvaihtoasennus": "menu item: ventilation installation",
  "valikon kohta: laippaliitokset": "menu item: flange joints",
  "valikon kohta (tarkastajan tunnus)": "menu item (inspector account)",
  "valikon kohta: walkdown": "menu item: walkdown",
  "valikon kohta: hintakatalogi": "menu item: price catalogue",
  "valikon kohta: resurssimitoitus": "menu item: resource sizing",
  "valikon kohta: puuttuvien hitsien kuittaus työnjohdolle (213)": "menu item: missing-weld sign-off for supervisors (213)",
  "näkymän otsikko (213, T445)": "view heading (213, T445)",
  "näkymän selite": "view description",
  "ratkaisu": "resolution",
  "rivin tila": "row status",
  "virhe": "error",
  "valinta: kohde": "selection: project",
  "aluesuodattimen nimi (ruudunlukija)": "area filter name (screen reader)",
  "aluesuodatin: kaikki; {n} avoimia": "area filter: all; {n} open",
  "aluesuodatin; {alue} {avoimia} {linjoja}": "area filter; {alue} {avoimia} {linjoja}",
  "tyhjä lista": "empty list",
  "tyhjä lista kenttätilillä": "empty list for a field account",
  "tyhjä lista alueella; {alue}": "empty list in area; {alue}",
  "linjan otsikko: alue; {alue}": "line heading: area; {alue}",
  "linjan otsikko: avoimia; {n}": "line heading: open; {n}",
  "linjan otsikko: kaikki kuitattu": "line heading: all signed off",
  "linja puuttuu line lististä": "line missing from the line list",
  "nappi: vienti Exceliin": "button: export to Excel",
  "tuontipaneelin otsikko": "import panel heading",
  "tuontipaneelin selite (sarakenimet pohjan otsikoita, ei käännetä)": "import panel description (column names are template headings, not translated)",
  "tuonti ilman kohdetta": "import without a project",
  "ilmoitus": "notice",
  "rivin otsikko; {nro}": "row heading; {nro}",
  "rivi: lehti; {lehti}": "row: sheet; {lehti}",
  "linkki isometriin": "link to the isometric",
  "kuittausrivin huomio: numero tai koko ei täsmää isometriin (linjakävelyn kohde)": "sign-off row note: number or size does not match the isometric (line walk item)",
  "ratkaisu (215): hitsi tehty, tekijä ja päivä eivät tiedossa": "resolution (215): weld done, welder and date unknown",
  "rivin tila (215): monen isometrin linja, isometriä ei voi varmistaa": "row status (215): multi-isometric line, isometric cannot be confirmed",
  "tuontipaneelin päivitysvalinta (versio)": "import panel update option (version)",
  "Tunnista linja -haun otsikko": "\"Identify line\" search heading",
  "Tunnista linja -hakukentän ohje": "\"Identify line\" search field instructions",
  "nappi": "button",
  "rajain": "filter",
  "rajain: putkiluokka": "filter: pipe class",
  "tulosten määrä; {n}": "number of results; {n}",
  "tuloksia enemmän kuin näytetään": "more results than shown",
  "ei tuloksia": "no results",
  "nappi: avaa linjan kuittaus; {n} avoimia": "button: open line sign-off; {n} open",
  "linjalla ei kuittausrivejä": "line has no sign-off rows",
  "osumatapa": "match type",
  "nappi: näytä isometri rinnalla": "button: show isometric side by side",
  "isometripaneelin otsikko, kun mitään ei ole valittu": "isometric panel heading when nothing is selected",
  "piirustusnumeroa ei ole järjestelmän isometreissä (214)": "drawing number not among the system's isometrics (214)",
  "isometri ei järjestelmässä; {tiedosto}": "isometric not in the system; {tiedosto}",
  "kuitatun rivin alku; {ratkaisu}": "start of a signed-off row; {ratkaisu}",
  "lomakkeen ryhmä": "form group",
  "lomakekenttä": "form field",
  "vaihe": "phase",
  "valikon kohta: linjojen ja hitsien selailu": "menu item: browsing lines and welds",
  "valikon kohta: käyttäjätunnukset": "menu item: user accounts",
  "valikon kohta: käännösten tarkistus (T440)": "menu item: translation review (T440)",
  "kirjautuminen epäonnistui": "sign-in failed",
  "virhe: raskas lista ylitti aikarajan (T465)": "error: heavy list exceeded the time limit (T465)",
  "kielivalinta: kieltä ei ole": "language option: language not available",
  "linjatarkastus: linjalla on tuotu tarkastus": "line inspection: the line already has an imported inspection",
  "nappi yläpalkissa / puhelimessa valikossa": "button in the top bar / in the menu on phone",
  "linkki nimen perässä valikossa": "link after the name in the menu",
  "näkymän otsikko": "view heading",
  "näkymän ohje": "view instructions",
  "lukitun sanaston otsikko": "locked glossary heading",
  "tarkistusnäkymän valinta: mihin kieleen käännöstä verrataan": "Translation review selector: which language the translation is compared with",
  "lukitun sanaston rivillä termin suomenkielisen muodon edessä": "Locked glossary row: label before the Finnish form of the term",
  "edistymä: «12 / 400 tarkistettu»": "progress: «12 / 400 tarkistettu»",
  "suodatin": "filter",
  "käännös puuttuu": "translation missing",
  "rivin tila: teksti muuttui tarkistuksen jälkeen": "row status: text changed after review",
  "rivin tila: tavallinen teksti, hyväksytty säännöllä eikä ihmisen katsomana": "row status: ordinary text, approved by rule rather than reviewed by a person",
  "rivin tila: korjaus hyväksyttiin, mutta käytössä on yhä toinen teksti": "row status: correction approved, but a different text is still in use",
  "edistymä kolmena lukuna": "progress as three numbers",
  "rivillä: ehdotettu korjaus": "on the row: suggested correction",
  "kenttä": "field",
  "nappi: käännös on oikein": "button: translation is correct",
  "nappi: korjaa käännös": "button: correct the translation",
  "nappi: hyväksy korjaus": "button: approve correction",
  "nappi: hylkää korjaus": "button: reject correction",
  "lista katkaistu": "list truncated",
  "virhe: tarkistajalla ei ole kieltä": "error: reviewer has no language",
  "lataustila": "loading state",
  "Omat tiedot -näkymän yläotsikko": "My details view overline",
  "ohjeen «kuka»": "help text «who»",
  "ohjeen «luvut»": "help text «numbers»",
  "kenttätekijä ei näe työmaata": "field worker cannot see the worksite",
  "miksi hitsausloki ei näy": "why the welding log is not visible",
  "tunnukseen ei ole kytketty henkilöä": "no person linked to the account",
  "otsikko": "heading",
  "pätevyyden voimassaolo ilman päivää": "qualification validity without a date",
  "kattavuusrivi: sääntö jätetty jonosta": "coverage row: rule left out of the queue",
  "kattavuusrivin selite": "coverage row description",
  "suodatin, sarake ja lomakkeen kenttä": "filter, column and form field",
  "suodattimen vaihtoehto": "filter option",
  "suodatin ja sarake": "filter and column",
  "tilasuodatin: avoin + käynnissä": "status filter: open + in progress",
  "tilasuodatin": "status filter",
  "suodatin, sarake ja kenttä": "filter, column and field",
  "nappi ja lomakkeen otsikko": "button and form heading",
  "tunnusluku: «12 avointa»": "key figure: «12 avointa»",
  "tunnusluku: «12 riviä»": "key figure: «12 riviä»",
  "tunnusluku: «2 pysäyttää»": "key figure: «2 pysäyttää»",
  "tunnusluku": "key figure",
  "sarake: puutteen kuvaus": "column: issue description",
  "sarake ja kenttä": "column and field",
  "sarake ja kenttä: havaintopäivä": "column and field: date observed",
  "sarake ja otsikko": "column and heading",
  "havainnosta kulunut aika": "time elapsed since observation",
  "kuka sulki puutteen": "who closed the issue",
  "selite": "description",
  "sääntö sulki puutteen": "a rule closed the issue",
  "kertymä": "accumulation count",
  "napin selite": "button description",
  "nimiehdotuksen selite": "name suggestion description",
  "nappi: tila käynnissä": "button: status in progress",
  "kentän esimerkki": "field placeholder",
  "kenttä: kuvaus": "field: description",
  "valintaruutu": "checkbox",
  "nappi lähetyksen aikana": "button while submitting",
  "päivärahavalinta": "per diem option",
  "päivärahavalinta ja asetus": "per diem option and setting",
  "rivin päiväraha (oli koodi «osa»)": "row per diem (was code «osa»)",
  "rivin päiväraha (oli koodi «koko»)": "row per diem (was code «koko»)",
  "tehtävälajin ehdotus (tallentuu suomeksi)": "task type suggestion (saved in Finnish)",
  "tehtävälajin ehdotus": "task type suggestion",
  "jakson alku": "period start",
  "jakson loppu": "period end",
  "nappi: asetukset": "button: settings",
  "linkki": "link",
  "linkin selite": "link description",
  "otsikko + jakso": "heading + period",
  "sarake": "column",
  "asetuskenttä": "settings field",
  "otsikon selite": "heading description",
  "varoitus": "warning",
  "varoituksen selite": "warning description",
  "erottelu": "breakdown",
  "erottelun selite": "breakdown description",
  "vahvistus": "confirmation",
  "henkilövalinnan oletus": "default person selection",
  "yksikkö": "unit",
  "asetusten selite": "settings description",
  "virhe: osoitteessa ei numeroa": "error: no number in the address",
  "korvauksen päivä edessä": "date of the allowance in front",
  "ohje": "instructions",
  "tila + päivä": "status + date",
  "tila": "status",
  "tila: «Hallussa: nimi»": "status: «Hallussa: nimi»",
  "nimi puuttuu": "name missing",
  "tyhjä arvo": "empty value",
  "valinnan tyhjä vaihtoehto": "empty option in a selection",
  "voimassaolo": "validity",
  "kenttä: valmistaja ja malli": "field: manufacturer and model",
  "kysymys lisäyksen jälkeen": "question after adding",
  "esimerkki": "example",
  "kysymys": "question",
  "tyhjä haku": "empty search",
  "mittauksen tulos": "measurement result",
  "mittauksen tulos: kalibrointi vanhentunut": "measurement result: calibration expired",
  "mittauksen tulos puuttuu": "measurement result missing",
  "yhteenvedon otsikko": "summary heading",
  "ei mitattavaa": "nothing to measure",
  "yhteenveto": "summary",
  "lohkon otsikko": "section heading",
  "puutteen vaikutus": "issue impact",
  "havaintopäivä": "date observed",
  "järjestelmän valmius": "system readiness",
  "sarake: tiiviysluokka": "column: tightness class",
  "sarake: P1-puhtausluokan suojaus": "column: P1 cleanliness class protection",
  "tyhjä taulukko": "empty table",
  "tyhjä": "empty",
  "arvo puuttuu": "value missing",
  "ei kuitattu": "not signed off",
  "pieni nappi": "small button",
  "tiiviyden raja": "tightness limit",
  "ei päätteitä": "no terminal units",
  "valinnassa": "in the selection",
  "vihje": "hint",
  "lomakkeen otsikko": "form heading",
  "lomakkeen selite": "form description",
  "Hitsausloki, kenttätili ilman hitsaajan työlajia": "Welding log, field account without the welder trade",
  "nimeämätön resurssipaikka, työsuhde alihankinta": "unnamed resource slot, employment type subcontracting",
  "nimeämätön resurssipaikka, työsuhde vuokra": "unnamed resource slot, employment type hired labour",
  "nimeämätön resurssipaikka, muu": "unnamed resource slot, other",
  "lukumäärä, n ≥ 2": "count, n ≥ 2",
  "Materiaalikatalogi: nimen esimerkki": "Material catalogue: name placeholder",
  "Materiaalikatalogi: kentän otsikko": "Material catalogue: field heading",
  "Materiaalikatalogi: yksikön esimerkki": "Material catalogue: unit placeholder",
  "Laippaliitokset: kentän otsikko": "Flange joints: field heading",
  "kentän otsikko": "field heading",
  "estetyn napin syy": "reason for a disabled button",
  "roolin nimi": "role name",
  "roolin nimi (rooli suunnittelija)": "role name (role planner)",
  "kentän esimerkki (esim. edessä)": "field placeholder (\"esim.\" in front)",
  "napin vieressä, kun nappi on estetty": "next to the button when the button is disabled",
  "tyhjä lista luojalle": "empty list for the creator",
  "laitteiden määrä": "number of devices",
  "lyhenne rivillä": "abbreviation on the row",
  "laitekortti": "device card",
  "takaisin-nappi": "back button",
  "yläotsikko": "overline",
  "edistymä": "progress",
  "kuittauksen vahvistus": "sign-off confirmation",
  "tyhjä tila": "empty state",
  "valmis": "done",
  "iso nappi": "large button",
  "napin alla": "below the button",
  "estoluokka A": "blocking class A",
  "estoluokka B": "blocking class B",
  "estoluokka C": "blocking class C",
  "estoluokan A määritelmä": "definition of blocking class A",
  "estoluokan B määritelmä": "definition of blocking class B",
  "estoluokan C määritelmä": "definition of blocking class C",
  "otsikon määrä": "count in the heading",
  "rivillä: «· hitsi 12»": "on the row: «· hitsi 12»",
  "nappi ilman oikeutta": "button without permission",
  "nappi: kuittaa korjatuksi": "button: sign off as fixed",
  "kentän selite": "field description",
  "valinnan selite": "selection description",
  "väliotsikko": "subheading",
  "rivillä: «korjattu nimi · pvm»": "on the row: «korjattu nimi · pvm»",
  "nappi: avaa korjattu uudelleen": "button: reopen a fixed item",
  "päivä sanoin: «Kirjataan päivälle sunnuntailta 5.10.»": "day in words: «Kirjataan päivälle sunnuntailta 5.10.»",
  "päivä sanoin, maanantai": "day in words, Monday",
  "päivä sanoin, tiistai": "day in words, Tuesday",
  "päivä sanoin, keskiviikko": "day in words, Wednesday",
  "päivä sanoin, torstai": "day in words, Thursday",
  "päivä sanoin, perjantai": "day in words, Friday",
  "päivä sanoin, lauantai": "day in words, Saturday",
  "osan nimike valintalistassa": "part item name in the dropdown",
  "hitsin laji A (tarkastuslaitoksen luokitus)": "weld type A (inspection body classification)",
  "hitsin laji E": "weld type E",
  "hitsin laji R": "weld type R",
  "hitsin laji S (nimi päättämättä, ks. api.ts HITSITYYPIT)": "weld type S (name undecided, see api.ts HITSITYYPIT)",
  "otsikko kun tunnus ei saa kirjata": "heading when the account may not record",
  "selite kun tunnus ei saa kirjata": "description when the account may not record",
  "otsikko ja nappi: istunnon aloitus": "heading and button: start session",
  "kirjaus: numero on jo esivalmistettu, kirjataan asennuksena; {pvm} {koodi}": "recording: number already prefabricated, recorded as installation; {pvm} {koodi}",
  "kirjaus: numero on jo asennettu; {pvm} {koodi}": "recording: number already installed; {pvm} {koodi}",
  "ilmoitus «Hitsi N …»: toinen vaihe kirjattu olemassa olevalle hitsille; {vaihe}": "notice «Hitsi N …»: second phase recorded for an existing weld; {vaihe}",
  "vaiheen nimi": "phase name",
  "nappi: sauma jää tekemättä": "button: joint will not be made",
  "napin selite (title)": "button description (title)",
  "ilmoitus kun kenttätekijä on esittänyt": "notice when a field worker has proposed",
  "ilmoitus kun merkintä on tehty": "notice when the entry has been made",
  "«Hitsiä ei tehdä» -ikkunan otsikko": "«Hitsiä ei tehdä» dialog heading",
  "kenttä: piirustuslehti": "field: drawing sheet",
  "lehtikentän paikkamerkki": "sheet field placeholder",
  "lehtikentän paikkamerkki kun lehtiä ei ole": "sheet field placeholder when there are no sheets",
  "kenttä: hitsin numero": "field: weld number",
  "numerokentän paikkamerkki": "number field placeholder",
  "kenttä: miksi sauma jää tekemättä": "field: why the joint will not be made",
  "perustekentän paikkamerkki": "reason field placeholder",
  "nappi: tallenna merkintä": "button: save entry",
  "nappi: sulje ikkuna": "button: close dialog",
  "vihje: suurin kirjattu numero; {suurin}": "hint: highest recorded number; {suurin}",
  "vihjeen jatko: numerottomat rivit; {n}": "hint continued: rows without a number; {n}",
  "vihjeen jatko": "hint continued",
  "vihje kun numeroituja ei ole": "hint when there are no numbered ones",
  "huomio: useita lehtiä; {n}": "note: several sheets; {n}",
  "ikkunan selite": "dialog description",
  "virhe: tallennus epäonnistui": "error: saving failed",
  "ohjelaatikon otsikko: kuka saa tehdä mitä": "help box heading: who may do what",
  "ohjelaatikon oletusotsikko: mitä luvut tarkoittavat": "help box default heading: what the numbers mean",
  "ohjelaatikon tiivistelmän alku": "start of the help box summary",
  "ohjelaatikon kytkin auki-tilassa": "help box toggle in open state",
  "ohjelaatikon kytkin kiinni-tilassa": "help box toggle in closed state",
  "tulosteen kielivalitsimen otsikko (vaihe c)": "printout language selector heading (phase c)",
  "tulosteen kieli: kohteen oletus": "printout language: project default",
  "yläpalkki: valitun kohteen otsikko (sanasto: kohde = project)": "top bar: selected project heading (glossary: kohde = project)",
  "yläpalkki: ei kohdesuodatinta": "top bar: no project filter",
  "näkymä joka ei suodata yläpalkin kohteella": "view that does not filter by the top-bar project",
  "linkki Excel-tulosteeseen": "link to the Excel printout",
  "linkki viralliseen lokiin (tarkastuslaitokselle)": "link to the official log (for the inspection body)",
  "nappi: lopeta istunto ja valitse toinen linja": "button: end session and choose another line",
  "kysymys kun istunto on edelliseltä päivältä": "question when the session is from the previous day",
  "nappi: kirjaa tälle päivälle (päiväys perässä)": "button: record for today (date after)",
  "nappi: jatka edellisen päivän kirjausta": "button: continue the previous day's recording",
  "teksti ennen päivää: «Kirjataan päivälle maanantailta 6.10.»": "text before the date: «Kirjataan päivälle maanantailta 6.10.»",
  "ilmoitus kun istunnon linja on poistettu": "notice when the session's line has been deleted",
  "vihje: työmaa valittiin työvarauksesta": "hint: worksite was selected from the work allocation",
  "vihje: yhtään työmaata ei näy": "hint: no worksite is visible",
  "virhe kun lomakkeen tiedot eivät latautuneet": "error when the form data did not load",
  "virhe: linkin linjaa ei löydy": "error: the linked line is not found",
  "virhe: linkin tunnus useassa kohteessa": "error: the linked identifier is in several projects",
  "tilannekuvan luvun selite": "status snapshot figure description",
  "tilannekuvan luvun selite (dia-inch)": "status snapshot figure description (dia-inch)",
  "peruskenttätilin tilannekuva: omat hitsit tänään": "basic field account snapshot: own welds today",
  "peruskenttätilin tilannekuva: omat halkaisijatuumat": "basic field account snapshot: own diameter inches",
  "otsikko: viimeisimmät linjat": "heading: latest lines",
  "piirustuslehti tekstin keskellä: «lehti 2/4»": "drawing sheet mid-text: «lehti 2/4»",
  "hitsien määrä: «12 hitsiä»": "number of welds: «12 hitsiä»",
  "kun avoimia puutteita ei ole": "when there are no open issues",
  "otsikko: avoimet puutteet": "heading: open issues",
  "otsikon selite: järjestys": "heading description: sort order",
  "puutteen vastuu puuttuu": "issue responsibility missing",
  "puutteen vastuu on ulkoinen": "issue responsibility is external",
  "puutteen havaintoaika": "issue observation time",
  "nappi puutteen rivillä": "button on an issue row",
  "istuntolomakkeen otsikko ennen linjan valintaa": "session form heading before a line is selected",
  "istuntolomakkeen selite": "session form description",
  "kenttä: linjan haku": "field: line search",
  "haku ei löytänyt: «Ei osumia haulla 100»": "search found nothing: «Ei osumia haulla 100»",
  "jatkuu: «… valitusta kohteesta»": "continues: «… valitusta kohteesta»",
  "jatkuu hakuvihjeessä": "continues in the search hint",
  "hakukentän ohje ennen kahta merkkiä": "search field instructions before two characters",
  "linjalla ei ole isometriä": "line has no isometric",
  "virhe: kenelläkään ei ole hitsaajaosaamista": "error: nobody has the welder trade",
  "valintalistan tyhjä vaihtoehto": "empty dropdown option",
  "valintalistan vaihtoehto: kirjoita itse": "dropdown option: type it yourself",
  "DN-kentän selite: arvo johdettu isometrin mitasta": "DN field description: value derived from the isometric dimension",
  "kenttä ja sarake: hitsaaja": "field and column: welder",
  "oma koodi hitsaajavalinnassa: «AB · minä»": "own code in the welder selection: «AB · minä»",
  "virhe: oma koodi ei ole hitsaajalistalla": "error: own code is not on the welder list",
  "kenttä: hitsaajan pari": "field: welder's partner",
  "kenttä: hitsausprosessi (141, 111…)": "field: welding process (141, 111…)",
  "kenttä: materiaali": "field: material",
  "kenttä: lisäaine": "field: filler metal",
  "virhe: materiaali puuttuu": "error: material missing",
  "virhe: piirustuslehti puuttuu": "error: drawing sheet missing",
  "vihje: linjalla ei ole isometriä": "hint: line has no isometric",
  "valintalistan vaihtoehto: muu": "dropdown option: other",
  "vapaan nimikkeen kentän esimerkki": "free item name field placeholder",
  "virhe: hitsinumero puuttuu": "error: weld number missing",
  "kirjauksen huomio": "recording note",
  "kirjauksen tulos: sama lähetys toistui": "recording result: the same submission was repeated",
  "kirjauksen tulos: suunniteltu täydennettiin": "recording result: a planned weld was completed",
  "kirjauksen tulos": "recording result",
  "kenttä, sarake ja ilmoitus: «Hitsi 12 kirjattu»": "field, column and notice: «Hitsi 12 kirjattu»",
  "virhe kun palvelin ei vastannut": "error when the server did not respond",
  "istuntorivillä: «kohde N-2410»": "on the session row: «kohde N-2410»",
  "ohjeen «kuka» kirjausnäkymässä": "help text «who» in the recording view",
  "ohjeen lukujen otsikko": "help text numbers heading",
  "ohje: hitsinumeroinnin säännöt": "help: weld numbering rules",
  "kenttä: alinumerohitsin peruste": "field: reason for a sub-numbered weld",
  "perustekentän esimerkki": "reason field placeholder",
  "alinumeron selite": "sub-number description",
  "kenttä: hitsitarran numero": "field: weld tag number",
  "numerolistan otsikko": "number list heading",
  "suunnitellun numeron selite": "planned number description",
  "alinumeron ehdotus": "sub-number suggestion",
  "alinumeroa haetaan": "fetching sub-number",
  "numerolistan otsikko: aukot": "number list heading: gaps",
  "nappi: vaihda sulatukset": "button: swap heats",
  "osan rivi: «Osa 1»": "part row: «Osa 1»",
  "osan nimi tekstissä: «osa 1»": "part name in text: «osa 1»",
  "kenttä: osan nimike": "field: part item name",
  "kenttä: sulatusnumero": "field: heat number",
  "sulatuskentän esimerkki": "heat field placeholder",
  "kenttä: materiaali koskee molempia osia": "field: material applies to both parts",
  "materiaalikentän esimerkki": "material field placeholder",
  "osan sulatus puuttuu": "part heat missing",
  "este: istunnon linja eri kohteessa kuin yläpalkin valinta": "block: session's line is in a different project than the top-bar selection",
  "kirjausnappi lähetyksen aikana": "record button while submitting",
  "kirjausnappi": "record button",
  "virheen jatko: istunnon kenttä": "error continued: session field",
  "vihje kirjausnapin alla": "hint below the record button",
  "taulukon otsikko": "table heading",
  "taulukon selite": "table description",
  "nappi: kuvien määrä": "button: number of photos",
  "nappi: lisää kuva hitsiin": "button: add photo to weld",
  "nappi: korjaa kirjattua hitsiä": "button: correct a recorded weld",
  "kuvalohkon otsikko": "photo section heading",
  "nappi: valitse muu päivä": "button: choose another date",
  "linjan merkki: yhdeltä hitsiltä puuttuu VT": "line badge: one weld is missing VT",
  "linjan merkki: hitseiltä puuttuu VT": "line badge: welds are missing VT",
  "linjan merkki: VT-rivi on mutta tulos ei hyväksytty": "line badge: VT row exists but result not accepted",
  "linjatarkastuksen kohta 7.1": "line inspection item 7.1",
  "linjatarkastuksen kohta 7.2": "line inspection item 7.2",
  "linjatarkastuksen kohta 7.3": "line inspection item 7.3",
  "linjatarkastuksen kohta 7.4": "line inspection item 7.4",
  "linjatarkastuksen kohta 7.5": "line inspection item 7.5",
  "linjatarkastuksen kohta 7.6": "line inspection item 7.6",
  "linjatarkastuksen kohta 7.7": "line inspection item 7.7",
  "linjatarkastuksen kohta 7.8": "line inspection item 7.8",
  "linjatarkastuksen kohta 7.9": "line inspection item 7.9",
  "linjatarkastuksen kohdan ohje": "line inspection item guidance (what to check, example entries)",
  "kohdan tulos: ei vielä valittu": "item result: not yet selected",
  "hyväksynnän este": "approval blocker",
  "hyväksynnän este: avoimia punch-kohtia": "approval blocker: open punch items",
  "hyväksynnän este: luovutuspäivä tulevaisuudessa": "approval blocker: handover date in the future",
  "hyväksynnän este: edustaja puuttuu (222)": "approval blocker: representative missing (222)",
  "hyväksynnän este: punchien tila lukematta": "approval blocker: punch status not read",
  "hyväksynnän este: avoimia A-luokan puncheja": "approval blocker: open class A punches",
  "lataus": "loading",
  "linjatarkastuksen otsikko": "line inspection heading",
  "tila: hyväksytty": "status: approved",
  "tuotu hyväksyntä: hyväksyjä on lähteen pöytäkirja": "imported approval: the approver is the source record",
  "tila: kesken": "status: in progress",
  "tila: ei aloitettu": "status: not started",
  "kohdan huomiokenttä": "item notes field",
  "kenttä: tarkastuspäivä": "field: inspection date",
  "lohkon otsikko (222)": "section heading (222)",
  "lohkon ohje (222, Toni 10.10.2026)": "section instructions (222, Toni 10.10.2026)",
  "luovutusrivi": "handover row",
  "luovutuslohkon huomautus": "handover section note",
  "huomautus: ei oikeutta poikkeamaan": "note: no permission for a deviation",
  "napin vihje (222)": "button hint (222)",
  "nappi (222)": "button (222)",
  "hyväksyntärivi (222)": "approval row (222)",
  "luovutusrivi: kirjattu poikkeama": "handover row: recorded deviation",
  "liitelohkon otsikko": "attachments section heading",
  "liite puuttuu": "attachment missing",
  "napin vihje": "button hint",
  "valmiuden syy (kannasta)": "readiness reason (from the database)",
  "linjan merkki": "line badge",
  "välilehti": "tab",
  "suodattimen arvo": "filter value",
  "kenttä / sarake": "field / column",
  "hakukentän esimerkki": "search field placeholder",
  "kenttä / sarake / välilehti": "field / column / tab",
  "listan merkki": "list badge",
  "suodattimen arvo / merkki": "filter value / badge",
  "yhteenvedon selite": "summary description",
  "valintaruudun nimi": "checkbox label",
  "rivin merkki": "row badge",
  "isometri: on": "isometric: yes",
  "isometri: ei": "isometric: no",
  "tyhjä nippu": "empty bundle",
  "edistyminen": "progress",
  "napin nimi": "button label",
  "paluunappi": "back button",
  "linja ilman tunnusta": "line without an identifier",
  "hitsin NDT-tila": "weld NDT status",
  "hitsin vaihe": "weld phase",
  "hitsin kortti": "weld card",
  "kaikkien punchien otsikko": "all punches heading",
  "otsikon jatko: avoimia": "heading continued: open",
  "otsikon jatko: haun tulos": "heading continued: search result",
  "laskuri": "counter",
  "sarake: estoluokka": "column: blocking class",
  "sarake: punchin kuvaus": "column: punch description",
  "sarake: kuka havaitsi": "column: who observed",
  "linkin vihje": "link hint",
  "tila: korjattu + päivä": "status: fixed + date",
  "tila: suljettu ilman kuittaajaa": "status: closed without a signer",
  "kohdevalinta: kaikki kohteet": "project selection: all projects",
  "ohje: kuka näkee": "help: who can see",
  "ohje: luvut": "help: numbers",
  "tunnusluvun jatko": "key figure continued",
  "tunnusluku: kattavuus": "key figure: coverage",
  "kaavion nimi": "chart name",
  "kaavion teksti": "chart text",
  "ei oikeutta": "no permission",
  "ohje: kuka": "help: who",
  "kohdevalinta": "project selection",
  "luku": "number",
  "avattava tilaajalle (T464)": "expandable for the client (T464)",
  "avattava": "expandable",
  "hakukenttä": "search field",
  "sarake / kenttä": "column / field",
  "merkin vihje": "badge hint",
  "merkki isoin kirjaimin": "badge in capital letters",
  "linkki PDF:ään": "link to the PDF",
  "OCR-vahvistus": "OCR confirmation",
  "nappi tallennuksen aikana": "button while saving",
  "lomakkeen ohje": "form instructions",
  "virhe tiedostonimen jälkeen": "error after the file name",
  "tiedostotyypin merkki isoin kirjaimin": "file type badge in capital letters",
  "merkki": "badge",
  "lähetys": "upload",
  "vihje: arkaluonteiset liitteet": "hint: sensitive attachments",
  "vastuun ehdotus": "responsibility suggestion",
  "välilehtien nimi": "tabs label",
  "piirustus ilman numeroa": "drawing without a number",
  "piirustuslehti": "drawing sheet",
  "merkintöjen määrä": "number of markups",
  "välilehti: valokuva": "tab: photo",
  "revisio korvattu": "revision superseded",
  "kirjan kokoonpano": "book composition",
  "kuvan alt": "image alt text",
  "merkintä": "markup",
  "merkinnän tiedot": "markup details",
  "hitsin laji S (lisätesti), Selailun sarake ja korjauslomake": "weld type S (additional test), Browse column and correction form",
  "virhe: vahvistusta odottavien hitsien haku": "error: fetching welds awaiting confirmation",
  "virhe: punakynän historian haku": "error: fetching redline history",
  "virhe: punakynän vahvistus": "error: redline confirmation",
  "virhe: punakynän hylkäys": "error: redline rejection",
  "virhe: punakynän hyväksynnän peruutus": "error: cancelling redline approval",
  "virhe: lisähitsin alinumeroehdotuksen haku": "error: fetching the sub-number suggestion for an added weld",
  "virhe: lisähitsin tallennus": "error: saving the added weld",
  "virhe: «ei toteudu» -merkinnän tallennus": "error: saving the «ei toteudu» entry",
  "jaetun linkin virhe: linjaa ei löydy": "shared link error: line not found",
  "jaetun linkin ilmoitus: vanha linjatunnus ohjattiin korvaajaan; {miten} = lähde ratkaisi tai mekanismin tunniste": "shared link notice: old line identifier redirected to its replacement; {miten} = source resolved or mechanism identifier",
  "korvauksen syy: lähteen master ratkaisi": "replacement reason: resolved in the source master",
  "isometri: linjan valokuvan lisäysnappi (kamera)": "isometric: add-line-photo button (camera)",
  "korvausilmoituksen jatko kun uusi linja ei näy käyttäjälle": "replacement notice continued when the new line is not visible to the user",
  "jaetun linkin virhe: linja passiivinen ilman korvaajaa": "shared link error: line inactive without a replacement",
  "jaetun linkin virhe: sama tunnus usealla kohteella": "shared link error: same identifier in several projects",
  "Selailun ohje: kuka saa tehdä mitä": "Browse help: who may do what",
  "Selailun ohje: mitä luvut tarkoittavat": "Browse help: what the numbers mean",
  "tuontipaneelin selite: linjat": "import panel description: lines",
  "tuontipaneelin esto: kohde valitsematta": "import panel block: project not selected",
  "tuontipaneelin valintaruutu: päivitä olemassa olevat": "import panel checkbox: update existing ones",
  "tuontipaneelin selite: NDT-vaatimukset": "import panel description: NDT requirements",
  "tuontipaneelin selite: WPS": "import panel description: WPS",
  "linjahaun esimerkkiteksti": "line search placeholder text",
  "nappi ja otsikko: kaikkien linjojen hitsit": "button and heading: welds of all lines",
  "nappi: kaikki punchit linjojen yli": "button: all punches across lines",
  "nappi: hitsit joilla vahvistamaton punakynämuutos": "button: welds with an unconfirmed redline change",
  "tyhjä linjalista": "empty line list",
  "linjalistan määrän perään: «844 linjaa»": "after the line list count: «844 linjaa»",
  "linjalistan rajaus: «· näytetään 1000»": "line list limit: «· näytetään 1000»",
  "linjalistan selite": "line list legend: what the numbers next to each line mean",
  "linjalistan luvun vihje": "line list number tooltip",
  "Selailun suodatin": "Browse view filter",
  "linjarivin punch-merkin vihje": "line row punch badge hint",
  "linjarivin merkki: «3 punch»": "line row badge: «3 punch»",
  "ohje kun mitään ei ole valittu": "instructions when nothing is selected",
  "vahvistusjono tyhjä (koosteen linkki voi osua tyhjään)": "confirmation queue empty (the summary link may land on an empty one)",
  "hitsilistan otsikko: vahvistusta odottavat": "weld list heading: awaiting confirmation",
  "hitsilistan otsikko: kaikki linjat": "weld list heading: all lines",
  "hitsilistan otsikko: kaikki linjat, lista rajattu": "weld list heading: all lines, list limited",
  "linjan otsikko: «· 42 hitsiä»": "line heading: «· 42 hitsiä»",
  "nappi: sulje linjan muokkaus": "button: close line editing",
  "nappi: avaa linjan muokkaus": "button: open line editing",
  "«Hitsiä ei tehdä» -napin vihje": "«Hitsiä ei tehdä» button hint",
  "linjan NDT-kattavuuslohkon otsikko": "line NDT coverage section heading",
  "NDT-kattavuus: vaatimusta ei kirjattu putkiluokalle": "NDT coverage: no requirement recorded for the pipe class",
  "NDT-kattavuus: linjalla ei PED-luokkaa": "NDT coverage: line has no PED category",
  "NDT-menetelmän vihje: vaadittu osuus ja kappaleet": "NDT method hint: required share and count",
  "NDT-menetelmän vihje: linjalla ei hitsejä": "NDT method hint: the line has no welds",
  "varoituksen otsikko: NDT-tarkastuksia liian vähän": "warning heading: too few NDT inspections",
  "NDT-vajeen selitys": "NDT shortfall explanation",
  "tyhjä hitsilista": "empty weld list",
  "sarake ja kenttä: hitsinumero": "column and field: weld number",
  "sarake ja kenttä: hitsin laji (A/E/R/S)": "column and field: weld type (A/E/R/S)",
  "sarake: hitsin osat ja sulatusnumerot": "column: weld parts and heat numbers",
  "sarakkeen vihje: sulatusnumero täydennetty jälkikäteen": "column hint: heat number filled in afterwards",
  "sarake (lyhenne): sulatus täydennetty": "column (abbreviation): heat filled in",
  "sarakkeen vihje: punakynä": "column hint: redline",
  "sarake: punakynämuutos": "column: redline change",
  "sarakkeen vihje: tarra": "column hint: tag",
  "hitsin laji valitsematta": "weld type not selected",
  "punakynän historian otsikko ja vihje": "redline history heading and hint",
  "punakynän tila": "redline status",
  "punakynän tila: vain työnjohdon hyväksymä": "redline status: approved by supervisors only",
  "hitsirivin linkki kuviin": "weld row link to photos",
  "punakynän vahvistusnapin vihje": "redline confirm button hint",
  "nappi ja otsikko: vahvista lisähitsi": "button and heading: confirm added weld",
  "nappi ja otsikko: vahvista ettei hitsiä tehdä": "button and heading: confirm the weld will not be made",
  "«+ hitsi» -napin vihje": "«+ hitsi» button hint",
  "nappi: lisää hitsi alinumerolla": "button: add weld with a sub-number",
  "«Ei toteudu» -napin vihje": "«Ei toteudu» button hint",
  "nappi: hitsi ei toteudu": "button: weld will not be made",
  "liiteosion otsikko hitsirivillä": "attachments section heading on a weld row",
  "linjan kenttä": "line field",
  "linjan kenttä: suunniteltujen hitsien määrä": "line field: number of planned welds",
  "linjan valintaruutu": "line checkbox",
  "hitsin korjauksen kenttä: «Osa 1 nimike»": "weld correction field: «Osa 1 nimike»",
  "hitsin korjauksen kenttä: «Osa 1 sulatus»": "weld correction field: «Osa 1 sulatus»",
  "hitsin korjauksen lohkon otsikko": "weld correction section heading",
  "hitsillä ei tarkastuksia": "weld has no inspections",
  "NDT-tuloksen valinta": "NDT result selection",
  "pöytäkirjanumeron tyhjä kenttä": "empty report number field",
  "tarkastuksen liiteosion otsikko": "inspection attachments section heading",
  "NDT-menetelmän valinta": "NDT method selection",
  "NDT-menetelmän valinnan vaihtoehto": "NDT method selection option",
  "pöytäkirjanumeron esimerkki": "report number placeholder",
  "punakynän historian laji": "redline history type",
  "punakynäikkunan otsikko toiminnon jälkeen": "redline dialog heading after the action",
  "punakynäikkunan muutoksen kuvaus": "redline dialog change description",
  "otsikko ja muutoksen kuvaus: hitsi ei toteudu": "heading and change description: weld will not be made",
  "lisähitsin emohitsi: «· emo 21»": "added weld's parent weld: «· emo 21»",
  "punakynä: vanha alinumero ilman esitystä": "redline: old sub-number without a proposal",
  "punakynän historian taso": "redline history level",
  "punakynän historian rivi peruttu": "redline history row cancelled",
  "napin vihje: perustelu puuttuu": "button hint: justification missing",
  "nappi: peru tämä hyväksyntä": "button: cancel this approval",
  "tyhjä punakynähistoria": "empty redline history",
  "kentän esimerkkiteksti": "field placeholder text",
  "peruutuslomakkeen otsikko": "cancellation form heading",
  "punakynäikkunan lyhyt ohje (kaksi lausetta)": "redline dialog short instructions (two sentences)",
  "avattavan lisätiedon otsikko": "expandable additional info heading",
  "hyväksyjän aseman valinta (peruutus)": "approver position selection (cancellation)",
  "aseman valinnan tyhjä vaihtoehto": "empty option in the position selection",
  "hyväksyjän aseman valinta": "approver position selection",
  "ulkopuolisen hyväksyjän kenttä": "external approver field",
  "ulkopuolisen hyväksyjän kentän esimerkki": "external approver field example",
  "punakynän historia: kirjaaja": "red-pen history: who recorded the entry",
  "punakynän historia: liitteet": "red-pen history: attachments of the approval",
  "punakynän historian sarake": "red-pen history column",
  "punakynän rivin tila": "red-pen row status",
  "aseman jatko: «Tilaajan valvoja — kelpaa luovutukseen»": "position continued: «Tilaajan valvoja — kelpaa luovutukseen»",
  "aseman jatko": "position continued",
  "nappi: avaa hylkäys": "button: open rejection",
  "napin vihje: vanha alinumero": "button hint: old sub-number",
  "punakynäikkunan ohje": "redline dialog instructions",
  "punakynäikkunan ohje, toinen osa ennen lihavointia": "redline dialog instructions, second part before the bold text",
  "punakynäikkunan ohje, lihavoitu": "redline dialog instructions, bold",
  "punakynäikkunan ohje, lihavoinnin jälkeen (alkaa pilkulla)": "redline dialog instructions, after the bold text (starts with a comma)",
  "ikkunan otsikko: «Lisää hitsi väliin — <linja>»": "dialog heading: «Lisää hitsi väliin — <linja>»",
  "ikkunan selite; {nro} lihavoidaan, {lehti} on tyhjä tai «lehdellä 2»": "dialog description; {nro} is bold, {lehti} is empty or «lehdellä 2»",
  "piirustuslehti lauseen sisällä": "drawing sheet within a sentence",
  "lisähitsin perustelukenttä kun hitsi on suunniteltu": "added weld justification field when the weld is planned",
  "lisähitsin perustelun esimerkki": "added weld justification placeholder",
  "lisähitsin tila": "added weld status",
  "nappi: lisää hitsatuksi": "button: add as welded",
  "nappi: lisää suunniteltuna": "button: add as planned",
  "lisähitsi-ikkunan ohje": "added weld dialog instructions",
  "lisähitsi-ikkunan ohjeen jatko suunnitellulle": "added weld dialog instructions continued for a planned weld",
  "virhe: lisähitsin numero ei ole emon alinumero": "error: added weld number is not a sub-number of the parent",
  "nappi: esitä ettei hitsiä tehdä": "button: propose that the weld will not be made",
  "«ei toteudu» -ikkunan ohje": "«ei toteudu» dialog instructions",
  "linjan puutelohkon otsikko": "line issues section heading",
  "linjan puutelohko tyhjä": "line issues section empty",
  "puuterivin kuvamäärä: «· kuvia 2»": "issue row photo count: «· kuvia 2»",
  "Hubin ohje: kuka näkee mitä": "hub help: who sees what",
  "roolilistan erotin": "role list separator",
  "ennusteen vaihe": "forecast phase",
  "ennusteen vaihe ilman syytä": "forecast phase without a reason",
  "ennusteen syy: valmiilta linjoilta puuttuu päivä": "forecast reason: completed lines are missing a date",
  "ennusteen syy: tuonti ei kata ikkunaa": "forecast reason: import does not cover the window",
  "ennusteen syy: ei arkipäiviä ikkunassa": "forecast reason: no weekdays in the window",
  "ennusteen syy: viimeisin valmistuminen ikkunan ulkopuolella": "forecast reason: latest completion outside the window",
  "ennusteen syy: ei valmistuneita linjoja": "forecast reason: no completed lines",
  "ennusteen syy: yksi päivä kantaa valtaosan": "forecast reason: one day carries the majority",
  "kohteen tilasiru": "project status chip",
  "tilasiru: kapasiteettiseuraus": "status chip: capacity consequence",
  "luvun linkin selite": "figure link description",
  "virhe: osoitteen kohdetta ei löydy": "error: project in the address not found",
  "asettelun lähde": "layout source",
  "tallennuskohde": "save target",
  "tallennuskohteen lisä": "save target addition",
  "ilmoitus: asettelu piilotti kaikki kortit": "notice: the layout hid all cards",
  "muokkaustilan ohje": "edit mode instructions",
  "Hubin ohje: luvut": "hub help: numbers",
  "kohde valittu yläpalkissa": "project selected in the top bar",
  "valitsimen otsikko": "selector heading",
  "valitsimen tyhjä vaihtoehto": "selector empty option",
  "valitsimen merkintä": "selector marker",
  "kortin merkintä muokkaustilassa": "card marker in edit mode",
  "kortin otsikko": "card heading",
  "perustiedot": "basic details",
  "siru": "chip",
  "kortti: kohteella ei linjoja": "card: project has no lines",
  "etenemäkortti": "progress card",
  "luvun perässä: «12 linjaa»": "after the number: «12 linjaa»",
  "palkin selite": "bar description",
  "palkin yksikkö": "bar unit",
  "etenemäkortti: vahvistettavat": "progress card: to be confirmed",
  "laatukortti": "quality card",
  "laatukortti: varoitus": "quality card: warning",
  "laiteasennuskortti": "equipment installation card",
  "IV-kortti": "ventilation (IV) card",
  "miehityskortti: lähde": "manning card: source",
  "tekijän merkintä": "worker marker",
  "työpakettien määrä": "number of work packages",
  "miehityskortti tyhjä": "manning card empty",
  "tarjouskortti": "offer card",
  "puutekortti tyhjä": "issues card empty",
  "luvun selite": "figure description",
  "luovutusvalmius: «12 aloitetusta»": "handover readiness: «12 aloitetusta»",
  "luovutusvalmius: «3 / 20 aloittamatta»": "handover readiness: «3 / 20 aloittamatta»",
  "luovutusvalmius: vaiheiden otsikko": "handover readiness: phases heading",
  "seuraava vaihe": "next phase",
  "luovutusvalmiuden kohta": "handover readiness item",
  "ennuste: päivä puuttuu": "forecast: date missing",
  "ennuste: päivä": "forecast: date",
  "ennuste: mittausikkuna puuttuu": "forecast: measurement window missing",
  "ennuste: mitä kokonaisennuste tarvitsee": "forecast: what the overall forecast needs",
  "punchin estoluokka puuttuu": "punch blocking class missing",
  "ennuste: kannakointirivi": "forecast: pipe support row",
  "kannakoinnin määritelmä": "pipe support definition",
  "kannakointirivi: tahti": "pipe support row: rate",
  "kannakointi": "pipe supports",
  "kannakointi: ketjussa": "pipe supports: in the chain",
  "kannakointi: mikä muuttaisi": "pipe supports: what would change it",
  "ennusteen selite": "forecast description",
  "ennusteen peruste": "forecast basis",
  "ennustetaulukon sarake": "forecast table column",
  "ennuste: tahti": "forecast: rate",
  "ennuste: tahdin peruste": "forecast: rate basis",
  "ennuste: tahdin hajonta": "forecast: rate spread",
  "ennuste: ikkuna leikattu": "forecast: window clipped",
  "ennuste: varoitus": "forecast: warning",
  "ennuste": "forecast",
  "ennusteen nimittäjä: otsikko": "forecast denominator: heading",
  "ennusteen nimittäjä": "forecast denominator",
  "kirjauskortti tyhjä": "recordings card empty",
  "estosivun syy": "block page reason",
  "estosivun yläotsikko": "block page overline",
  "estosivun otsikko": "block page heading",
  "estosivun osoite": "block page address",
  "estosivun selitys": "block page explanation",
  "estosivun ohje": "block page instructions",
  "kysymys ennen kirjausta, kun asiayhteys vaihtui": "question before recording when the context changed",
  "kysymyksen syy": "question reason",
  "nappi: sama sulatus": "button: same heat",
  "virhe: Excel-tuonti": "error: Excel import",
  "linkki: Excel-pohja": "link: Excel template",
  "tuonnin kuivakäynti": "import dry run",
  "tuonnin huomautus": "import note",
  "tuonnin otsikko": "import heading",
  "tuonnin rivi": "import row",
  "sarake: arvo järjestelmässä": "column: value in the system",
  "sarake: arvo tiedostossa": "column: value in the file",
  "tuonnin esikatselu": "import preview",
  "päivitysvalinnan selite": "update option description",
  "tuonnin tulos": "import result",
  "nappi: yhdistävä sana": "button: connecting word",
  "vahvistus: kertanäyttöisen salaisuuden sulkeminen ennen kopiointia": "confirmation: closing a show-once secret before copying",
  "kertanäyttö: lauseen alku ennen sähköpostiosoitetta": "show-once display: start of sentence before the email address",
  "kertanäyttö: lauseen loppu osoitteen jälkeen (alkaa pisteellä)": "show-once display: end of sentence after the address (starts with a full stop)",
  "kertanäyttö: salaisuus näytetään vain kerran": "show-once display: the secret is shown only once",
  "nappi kopioinnin jälkeen": "button after copying",
  "virhe: sähköpostilähetys": "error: sending email",
  "nappi: lähetä kutsulinkki sähköpostilla; {osoite}": "button: send invitation link by email; {osoite}",
  "sähköpostilähetys ei käytettävissä; {syy} = syy": "email sending not available; {syy} = reason",
  "syy: vastaanottajalla ei sähköpostiosoitetta": "reason: recipient has no email address",
  "nappi: kuittaa kertanäyttö ja sulje": "button: acknowledge the show-once display and close",
  "kenttävirhe: PIN-muoto": "field error: PIN format",
  "kenttävirhe: uusi PIN ja toisto eroavat": "field error: new PIN and confirmation differ",
  "virhe: PIN-vaihto": "error: PIN change",
  "otsikko ja nappi: kenttätilin pakotettu PIN-vaihto": "heading and button: forced PIN change for a field account",
  "ohje pakotetussa PIN-vaihdossa; {nimi}": "instructions in forced PIN change; {nimi}",
  "kameraskannaus: ei suojattua yhteyttä": "camera scan: no secure connection",
  "kameraskannaus: selain ei tue kameraa": "camera scan: browser does not support the camera",
  "kameraskannaus: QR-lukijan lataus kaatui; {syy}": "camera scan: loading the QR reader failed; {syy}",
  "kameraskannaus: lupa evätty": "camera scan: permission denied",
  "kameraskannaus: ei kameraa": "camera scan: no camera",
  "kameraskannaus: muu kameravirhe; {syy}": "camera scan: other camera error; {syy}",
  "kameraskannaus: QR ei ole kaluston tarra; {koodi}": "camera scan: QR is not an equipment tag; {koodi}",
  "nappi: avaa kamera tarran QR-koodin lukuun": "button: open the camera to read the tag's QR code",
  "tila: kamera avautuu": "status: camera opening",
  "ohje: osoita kameralla tarraa": "instructions: point the camera at the tag",
  "virhe: viestien haku": "error: fetching messages",
  "virhe: luetuksi merkintä": "error: marking as read",
  "Viestit-näkymän otsikko (yksisuuntaiset tiedotteet)": "Messages view heading (one-way announcements)",
  "Viestit-näkymän ohje: kuka saa tehdä mitä": "Messages view help: who may do what",
  "Viestit-näkymän ohje: mitä luvut tarkoittavat": "Messages view help: what the numbers mean",
  "otsikko: saapuneet viestit": "heading: received messages",
  "viestin voimassaolo; {pvm}": "message validity; {pvm}",
  "tila: luettu päivänä; {pvm}": "status: read on date; {pvm}",
  "estetyn Lähetä-napin syy": "reason for the disabled Send button",
  "vihje: viesteihin ei vastata": "hint: messages cannot be replied to",
  "teksti kun käyttäjällä ei ole lähetysoikeutta": "text when the user has no permission to send",
  "ilmoitus: vastaanottajia ei valittu": "notice: no recipients selected",
  "ilmoitus lähetyksen jälkeen; {n} = vastaanottajia": "notice after sending; {n} = recipients",
  "virhe: lähetys": "error: sending",
  "prompt: viestin peruutuksen peruste": "prompt: reason for cancelling the message",
  "virhe: peruutus": "error: cancellation",
  "otsikko: lähetyslomake": "heading: send form",
  "kenttä: vastaanottajien kohdistus": "field: recipient targeting",
  "kohdistus": "targeting",
  "kenttä: viestin voimassaolo": "field: message validity",
  "ohje: työnjohtajien valinta": "instructions: selecting supervisors",
  "valinta: kaikki kohteen työnjohtajat; {n}": "option: all supervisors of the project; {n}",
  "huomautus: kohteella ei työnjohtajia": "note: project has no supervisors",
  "kenttä: viestin otsikko": "field: message subject",
  "kenttä: viestin teksti": "field: message text",
  "vihje lähetyslomakkeen alla": "hint below the send form",
  "otsikko: lähetetyt viestit": "heading: sent messages",
  "tila: lukeneet / vastaanottajat; {x} {y}": "status: read / recipients; {x} {y}",
  "tila: viesti peruttu": "status: message cancelled",
  "tila: viesti vanhentunut": "status: message expired",
  "nappi: peru viesti": "button: cancel message",
  "avattava lista": "expandable list",
  "tila: vastaanottaja ei ole lukenut": "status: recipient has not read",
  "paneelin otsikko": "panel heading",
  "vuoron TES-lisän laji": "shift collective-agreement (TES) allowance type",
  "kentän vihje": "field hint",
  "ryhmän otsikkorivi": "group header row",
  "nappi: poista jäsen": "button: remove member",
  "valinta": "selection",
  "sarake ja valinnan selite": "column and selection description",
  "solu: jakso koskee koko ryhmää": "cell: period applies to the whole group",
  "jakson tila": "period status",
  "solu: oletusvuoro": "cell: default shift",
  "huomautus": "note",
  "kurssi ilman osaamisrataa": "course without a competence track",
  "kurssikortti": "course card",
  "kurssikortti: läpäisyn voimassaolo": "course card: validity of the pass",
  "nappi: suoritettu kurssi": "button: completed course",
  "nappi: vanhentunut kurssi": "button: expired course",
  "merkin selite: esiehto": "badge description: prerequisite",
  "kurssin tila": "course status",
  "otsikko ja sarake": "heading and column",
  "nappi: takaisin listaan": "button: back to the list",
  "kokeen tulos": "exam result",
  "nappi: takaisin kurssiin": "button: back to the course",
  "kokeen ohje": "exam instructions",
  "kysymyksen tyyppi": "question type",
  "tyhjä lista (hallinta)": "empty list (administration)",
  "sarake: osaamisrata": "column: competence track",
  "virhe: QR-tarra-arkki": "error: QR tag sheet",
  "QR-koetarra-arkin otsikko": "QR test tag sheet heading",
  "linkki: kalustonäkymään": "link: to the equipment view",
  "QR-tarra-arkin selite; {o} = osoite": "QR tag sheet description; {o} = address",
  "tarran varoitus: numero ei QR-sarjassa": "tag warning: number not in the QR series",
  "kohdevalinta: ei suodatinta": "project selection: no filter",
  "estelaatikon otsikko (allokointi/sidonta)": "blocker box heading (allocation/assignment)",
  "perustekentän merkintä": "reason field label",
  "ilmoitus: uusi versio": "notice: new version",
  "kenttätilin työmaavalinta": "field account worksite selection",
  "kenttätilin työmaavalinnan otsikko": "field account worksite selection heading",
  "työmaa ei aktiivinen": "worksite not active",
  "linkin title": "link title",
  "linkin vihje (T469)": "link hint (T469)",
  "virhe: henkilömäärä ei kokonaisluku; {n} = annettu luku": "error: headcount is not an integer; {n} = given number",
  "näkymän otsikko: voimmeko ottaa urakan": "view heading: can we take on the contract",
  "ohje: kuka saa käyttää": "help: who may use it",
  "ohje: mitä luvut tarkoittavat": "help: what the numbers mean",
  "sarake: henkilömäärä": "column: headcount",
  "nappi title": "button title",
  "nappi: kysy riittääkö väki": "button: ask whether the workforce is sufficient",
  "vastaus": "answer",
  "vastaus, ennen osaamisen nimeä": "answer, before the trade name",
  "vastaus, osaamisen nimen jälkeen": "answer, after the trade name",
  "tyhjä tulos": "empty result",
  "yksikkö: henkilöä": "unit: persons",
  "vihje; {v} = vaatimukset": "hint; {v} = requirements",
  "teksti lukujen jälkeen": "text after the numbers",
  "teksti": "text",
  "teksti; {lista} = puuttuvat": "text; {lista} = missing ones",
  "teksti (lihavoitu)": "text (bold)",
  "lyhenne: viikko; {n} = numero": "abbreviation: week; {n} = number",
  "vastauksen otsikko": "answer heading",
  "tilamerkki taulukossa": "status badge in the table",
  "nappi virheen jälkeen": "button after an error",
  "merkin vihje: todistuksia liitteenä": "badge hint: certificates attached",
  "nappi ja liiteotsikko": "button and attachment heading",
  "kenttä ja sarake": "field and column",
  "näkymän yläotsikko": "view overline",
  "ohjeen «luvut», alku": "help text «numbers», start",
  "ohjeen «luvut»: ✓-merkin selitys": "help text «numbers»: explanation of the ✓ mark",
  "ohjeen «luvut»: ◑-merkin selitys": "help text «numbers»: explanation of the ◑ mark",
  "ohjeen «luvut»: ?-merkin selitys": "help text «numbers»: explanation of the ? mark",
  "ohjeen «luvut», loppu": "help text «numbers», end",
  "tyhjä lohko": "empty section",
  "lohkon vihje": "section hint",
  "riskirivin otsikko": "risk row heading",
  "riskirivin teksti": "risk row text",
  "tyhjä lista: otsikko": "empty list: heading",
  "tyhjä lista: teksti": "empty list: text",
  "hakutuloksen huomautus": "search result note",
  "taulukon rivien yksikkö": "table row unit",
  "voimassaolo: umpeutunut": "validity: expired",
  "voimassaolo: jäljellä": "validity: remaining",
  "virhe: pätevyys tallentui, liite ei": "error: qualification saved, attachment not",
  "virheen varateksti": "error fallback text",
  "lomakkeen vihje": "form hint",
  "vihje: päivä annettu käsin": "hint: date entered manually",
  "vihje: päivä laskettu": "hint: date calculated",
  "vihje: tyyppi ei vanhene": "hint: type does not expire",
  "tyypin voimassaolo valintalistassa": "type validity in the dropdown",
  "henkilökortin lohko": "person card section",
  "poissaolon tila": "absence status",
  "ohje: luvut, parien määrä": "help: numbers, number of pairs",
  "ohje: luvut, jatkoa": "help: numbers, continued",
  "ohje: mittaushetki": "help: time of measurement",
  "ohje: ≤-merkin selitys": "help: explanation of the ≤ sign",
  "ohje: lihavoitu sääntö": "help: bold rule",
  "ohje: värien selitys": "help: colour explanation",
  "sarake: hitsausmenetelmä": "column: welding method",
  "sarake: hitsien määrä": "column: number of welds",
  "yksikkö luvun perässä": "unit after the number",
  "huomio": "note",
  "painekokeen tulos": "pressure test result",
  "painekokeen tulos: tuotu, lähde ei kertonut": "pressure test result: imported, source did not state",
  "osion otsikko": "section heading",
  "päivä puuttuu": "date missing",
  "tuodun lähdetekstin etuliite": "prefix of imported source text",
  "tila: kirjattu NDT:n ollessa kesken": "status: recorded while NDT was in progress",
  "NDT-portin ohituksen tiedot": "NDT gate override details",
  "kenttä: tiedosto": "field: file",
  "kenttä: ohituksen peruste": "field: override reason",
  "esimerkkiteksti": "placeholder text",
  "liitelistan otsikko": "attachment list heading",
  "tilasana: ei mitattu": "status word: not measured",
  "hakukentän placeholder": "search field placeholder",
  "hakukentän aria-label": "search field aria-label",
  "hakuselite: «Haku: «x» · 4 / 31 riviä»": "search description: «Haku: «x» · 4 / 31 riviä»",
  "lajitteluselite": "sort description",
  "nappi: tyhjennä haku ja järjestys": "button: clear search and sorting",
  "nappi: «Isometri 100-0221»": "button: «Isometri 100-0221»",
  "sarake: lukumäärä": "column: count",
  "sarake: kappaletta": "column: pieces",
  "kenttä: muu syy": "field: other reason",
  "otsikko: «Korjaa hitsi 12»": "heading: «Korjaa hitsi 12»",
  "hitsin numero puuttuu": "weld number missing",
  "placeholder": "placeholder",
  "kenttä: «Osa 1 sulatus»": "field: «Osa 1 sulatus»",
  "otsikon luku": "number in the heading",
  "sarake: kiristysmomentti": "column: tightening torque",
  "sarake: viimeisin kiristys": "column: latest tightening (value, status and warnings)",
  "solu": "cell",
  "solu: kiristetty ilman lukemaa": "cell: tightened without a reading",
  "virhe: yritystietohaku": "error: business information lookup",
  "taulukon hakuselitteen yksikkö (N / M …)": "unit in the table's search caption (N / M …)",
  "kenttä ja sarake: suomalainen yritystunnus": "field and column: Finnish business ID",
  "nappi haun aikana": "button while searching",
  "haun piilottamat rivit; {n} = määrä": "rows hidden by the search; {n} = count",
  "rivin merkintä; {pvm} = päivä": "row marker; {pvm} = date",
  "teksti; {pvm} = päivä, {kuka} = poistaja": "text; {pvm} = date, {kuka} = person who deleted",
  "teksti; {n} = tarjousten määrä": "text; {n} = number of offers",
  "nappi: avaa poistolomakkeen": "button: opens the deletion form",
  "paneelin otsikko: hitsauslokin Excel-muokkauskierto": "panel heading: Welding log Excel edit round-trip",
  "selite, lihavoitu": "caption, bold",
  "linkki: Excel-vienti": "link: Excel export",
  "vientilinkin tarkenne": "qualifier of the export link",
  "kuivakäynti: «12 riviä,»": "dry run: «12 riviä,»",
  "kuivakäynti: «30 kenttämuutosta.»": "dry run: «30 kenttämuutosta.»",
  "kuivakäynti": "dry run",
  "solu: taulu": "cell: table",
  "esikatselu": "preview",
  "tulos": "result",
  "kentän tarkenne": "field qualifier",
  "placeholder: esimerkkisijainti": "placeholder: example location",
  "kenttä: vaiheketju": "field: phase chain",
  "vaiheketjun vaihemäärä": "number of phases in the phase chain",
  "huomautus, lihavoitu": "note, bold",
  "luovutusvalmiuden joukko (suodatin)": "handover readiness set (filter)",
  "NDT-solu: valmis": "NDT cell: complete",
  "NDT-tila solussa": "NDT status in a cell",
  "NDT-solun selite (title)": "NDT cell explanation (title)",
  "tilanneleima": "status timestamp",
  "viennin selite": "export caption",
  "omistajuusvyö tilaajalle (T464)": "ownership band, client-facing (T464)",
  "omistajuusvyö": "ownership band",
  "tunnusluvun selite": "key figure caption",
  "sarake: putken väliaine": "column: pipe medium",
  "merkki: isometri puuttuu": "badge: isometric missing",
  "merkki: linjan nimen koko": "badge: size in the line name",
  "taulukon raja": "table limit",
  "paneelin otsikko tilaajalle (T464)": "panel heading, client-facing (T464)",
  "ohje: kuka, tilaajalle (T464)": "guidance: who, client-facing (T464)",
  "ohje: luvut, tilaajalle (T464)": "guidance: figures, client-facing (T464)",
  "paneelin vihje": "panel hint",
  "rivimäärän perässä": "after the row count",
  "suodattimen kuvaus": "filter description",
  "sarake: hitsausloki": "column: welding log",
  "NDT-solun selite": "NDT cell explanation",
  "painekoesolun selite": "pressure test cell explanation",
  "tunnusluku: puhdas": "key figure: clean",
  "kuivakäynti: «3 tuntematonta avainta»": "dry run: «3 tuntematonta avainta»",
  "kuivakäynti: «2 uutta liitosta»": "dry run: «2 uutta liitosta»",
  "sarake: primääri-/sekundääripiiri": "column: primary/secondary circuit",
  "vaiheen tila": "phase status",
  "nappi: peru vaihekuittaus": "button: undo phase sign-off",
  "solu: liitos auki": "cell: connection open",
  "otsikon tarkenne": "heading qualifier",
  "Kalusto: lajin välilehti ja otsikko": "Equipment: category tab and heading",
  "Kalusto: joukkohyväksynnän ilmoitus": "Equipment: bulk approval notice",
  "Kalusto: joukkohylkäyksen ilmoitus": "Equipment: bulk rejection notice",
  "Kalusto: virhe": "Equipment: error",
  "Kalusto: hakuselitteen yksikkö: «3 / 40 laitetta»": "Equipment: unit in the search caption: «3 / 40 laitetta»",
  "Kalusto: ohje: kuka näkee ja muokkaa": "Equipment: guidance: who sees and edits",
  "Kalusto: ohje: mitä luvut tarkoittavat": "Equipment: guidance: what the figures mean",
  "Kalusto: Excel-tuonnin otsikko": "Equipment: Excel import heading",
  "Kalusto: Excel-tuonnin selite": "Equipment: Excel import caption",
  "Kalusto: Excel-tuonnin valinta": "Equipment: Excel import selection",
  "Kalusto: lajisuodatin: kaikki": "Equipment: category filter: all",
  "Kalusto: suodatin: odottaa hyväksyntää": "Equipment: filter: awaiting approval",
  "Kalusto: valinta": "Equipment: selection",
  "Kalusto: nappi": "Equipment: button",
  "Kalusto: tyhjä tila välilehdellä": "Equipment: empty state on a tab",
  "Kalusto: tyhjä tila": "Equipment: empty state",
  "Kalusto: tyhjän tilan ohje koko yrityksen kalustovastaavalle": "Equipment: empty-state guidance for the company-wide equipment manager",
  "Kalusto: tyhjän tilan ohje kohteen kalustovastaavalle": "Equipment: empty-state guidance for the project's equipment manager",
  "Kalusto: tyhjän tilan ohje ilman oikeutta": "Equipment: empty-state guidance without permission",
  "Kalusto: hakukentän ohjeteksti": "Equipment: search field placeholder text",
  "Kalusto: lajittelun otsikko": "Equipment: sort heading",
  "Kalusto: lajitteluavain: tarkastuksen tila": "Equipment: sort key: inspection status",
  "Kalusto: lajitteluavain: seuraavan tarkastuksen päivä": "Equipment: sort key: next inspection date",
  "Kalusto: hakusuodattimen selite": "Equipment: search filter caption",
  "Kalusto: vahvistusrivi": "Equipment: confirmation line",
  "Kalusto: kenttä": "Equipment: field",
  "Kalusto: tyyppilistan ohje": "Equipment: type list guidance",
  "Kalusto: nappi: korjaa tyypin nimi": "Equipment: button: correct the type name",
  "Kalusto: nappi: palauta piilotettu tyyppi": "Equipment: button: restore a hidden type",
  "Kalusto: lomakkeen virhe": "Equipment: form error",
  "Kalusto: lomakkeen ohje": "Equipment: form guidance",
  "Kalusto: tyyppivalinnan vaihtoehto": "Equipment: type selection option",
  "Kalusto: esimerkki": "Equipment: example",
  "Kalusto: kunnon tyhjä vaihtoehto": "Equipment: empty option for condition",
  "Kalusto: valinnan tyhjä vaihtoehto": "Equipment: empty option of a selection",
  "Kalusto: kenttä: sijainnin nimi": "Equipment: field: location name",
  "Kalusto: ilmoitus": "Equipment: notice",
  "Kalusto: valintaruudun selite": "Equipment: checkbox caption",
  "Kalusto: valintaruudun nimi ruudunlukijalle": "Equipment: checkbox name for screen readers",
  "Kalusto: tarran numero rivillä": "Equipment: label number on the row",
  "Kalusto: tilasana": "Equipment: status word",
  "Kalusto: rivin tila + päivä": "Equipment: row status + date",
  "Kalusto: lyhenne: sarjanumero": "Equipment: abbreviation: serial number",
  "Kalusto: laitteen kunto tekstissä": "Equipment: device condition in running text",
  "Kalusto: tyhjä arvo": "Equipment: empty value",
  "Kalusto: ohje": "Equipment: guidance",
  "Kalusto: liiteosion otsikko": "Equipment: attachment section heading",
  "Kalusto: liiteosion otsikko: tarkastustodistus": "Equipment: attachment section heading: inspection certificate",
  "Kalusto: nappi: avaa poistolomake": "Equipment: button: open the deletion form",
  "Kalusto: tila": "Equipment: status",
  "Kalusto: tilan selitys": "Equipment: status explanation",
  "Kalusto: otsikko": "Equipment: heading",
  "Kalusto: tarkastuksen voimassaolo; päivä lihavoituna": "Equipment: inspection validity; date in bold",
  "Kalusto: tarkastuspäivä": "Equipment: inspection date",
  "Kalusto: kirjaaja ja päivä": "Equipment: recorded by and date",
  "kenttä ja sarake: osaamisrata": "field and column: competence track",
  "kenttä ja sarake: radan vaihe": "field and column: track stage",
  "valinta: tyhjä": "selection: empty",
  "kenttä ja sarake: työyksikkö (esim. laite)": "field and column: work unit (e.g. device)",
  "tason tila": "level status",
  "matriisin solu": "matrix cell",
  "sarake: eri yksiköiden määrä": "column: number of distinct units",
  "sarake: vastuuhenkilönä tehdyt": "column: done as the responsible person",
  "nimityksen myöntäjä": "granter of the appointment",
  "alkuperä": "origin",
  "vihje (jatkuu sanalla lepääväksi)": "hint (continues with the word lepääväksi, 'dormant')",
  "vihje: lihavoitu sana": "hint: bold word",
  "vihje (jatkoa)": "hint (continued)",
  "tason sääntö": "level rule",
  "säännön selite": "rule caption",
  "ehdon tila": "condition status",
  "ehdon syy": "condition reason",
  "arvioinnin tulos": "assessment result",
  "tulosteen otsikko": "printout heading",
  "tuloste": "printout",
  "tuloste: varoitus": "printout: warning",
  "tulosteen alaviite": "printout footnote",
  "työpaketin tila": "work package status",
  "valittu kohde": "selected project",
  "kentän otsikko isoin kirjaimin": "field heading in capitals",
  "tyhjä tila, jatko": "empty state, continuation",
  "kenttä isoin kirjaimin": "field in capitals",
  "kenttä: putken väliaine": "field: pipe medium",
  "valittujen yhteenveto": "summary of the selected items",
  "linkkinappi": "link button",
  "paketin rivi": "package row",
  "etenemä": "progress",
  "lyhenne: hitsien määrä": "abbreviation: number of welds",
  "määrä": "quantity",
  "sulatusten määrä lyhenteenä": "number of heats, abbreviated",
  "sarake: vielä otettava": "column: still to be drawn",
  "kutsulinkin sähköpostilähetys ei lähtenyt; {syy}": "invitation link email was not sent; {syy}",
  "syy puuttuu": "reason missing",
  "syy miksi kutsunappi ei lähetä ulkopuoliselle": "reason why the invite button does not send to an external user",
  "vahvistus: uusi PIN kenttätilille; {nimi} {koodi}": "confirmation: new PIN for a field account; {nimi} {koodi}",
  "virheilmoitus": "error message",
  "Tunnukset-näkymän otsikko": "Accounts view heading",
  "Tunnukset-näkymän ohje: kuka saa tehdä mitä": "Accounts view guidance: who may do what",
  "ohjeen toisen osan otsikko": "heading of the second part of the guidance",
  "Tunnukset-näkymän ohje": "Accounts view guidance",
  "kertanäytön otsikko": "one-time display heading",
  "kertanäytön otsikko ja nappi": "one-time display heading and button",
  "kertanäytön rivin selite": "one-time display row caption",
  "kutsulinkin kertanäytön vihje": "hint in the invitation link one-time display",
  "kertakäyttöisen salasanan vihje": "one-time password hint",
  "ilmoitus sähköpostilähetyksen jälkeen": "notice after the email is sent",
  "listan selite, osa 1 (ennen lihavoitua)": "list caption, part 1 (before the bold text)",
  "listan selite, lihavoitu": "list caption, bold",
  "listan selite, osa 2": "list caption, part 2",
  "listan selite, osa 3 (ennen lihavoitua «henkilö»)": "list caption, part 3 (before the bold «henkilö»)",
  "listan selite, osa 4": "list caption, part 4",
  "sarake ja osion otsikko": "column and section heading",
  "sarake ja osion otsikko: kohderajaus": "column and section heading: project scope",
  "sarake: voimassa olevat istunnot": "column: active sessions",
  "vientilokin alku; {pvm}": "start of the export log; {pvm}",
  "vientiloki tyhjä": "export log empty",
  "vientiloki tyhjä: selitys": "export log empty: explanation",
  "sarake: viety aineisto": "column: exported data",
  "tallennettu/tallentamaton osa": "saved/unsaved part",
  "tallentamaton osa": "unsaved part",
  "tallennettu osa": "saved part",
  "tallennettu osa; {n} kohdetta": "saved part; {n} projects",
  "ilmoitus; {osat}": "notice; {osat}",
  "ilmoitus: osa tallentui; {osat} {syy}": "notice: part was saved; {osat} {syy}",
  "ilmoitus; {syy}": "notice; {syy}",
  "vahvistus: toimittajan tukitunnuksen passivointi; {nimi}": "confirmation: deactivating the vendor support account; {nimi}",
  "vahvistus: tunnuksen lopullinen poisto; {nimi}": "confirmation: permanent deletion of the account; {nimi}",
  "prompt: avoimen kutsun mitätöinti; {nimi}": "prompt: cancelling an open invitation; {nimi}",
  "tila tunnusrivillä": "status on the account row",
  "tyhjä sähköpostisolu": "empty email cell",
  "näkyvyys: ei rajausta": "visibility: no restriction",
  "näkyvyys: yksi kohde": "visibility: one project",
  "näkyvyys: {n} kohdetta": "visibility: {n} projects",
  "ei koskaan kirjautunut": "never signed in",
  "selite: Auki nyt -luku": "caption: the «Auki nyt» (open now) figure",
  "tunnuksen tila": "account status",
  "selite: avoin kutsu; {pvm}": "caption: open invitation; {pvm}",
  "kutsun tila": "invitation status",
  "selite; {pvm}": "caption; {pvm}",
  "tunnuksen numero (tukea varten)": "account number (for support)",
  "ilmoitus; {n}": "notice; {n}",
  "vihje: henkilöliitos": "hint: link to a person",
  "tunnuksen laji: järjestelmätunnus (vahti)": "account type: system account (watchdog)",
  "tunnuksen laji: toimittajan tukitunnus": "account type: vendor support account",
  "tunnuksen laji: ulkopuolinen": "account type: external",
  "vihje: arkaluonteisten tietojen oikeus": "hint: sensitive data permission",
  "lihavoitu huomautus": "bold note",
  "vihje: kohderajaus": "hint: project scope",
  "tila napin vieressä; {osat}": "status next to the button; {osat}",
  "luettelon erotin (välilyönnit mukana)": "list separator (spaces included)",
  "tila napin vieressä": "status next to the button",
  "uuden tunnuksen lomakkeen selite": "new account form caption",
  "hakuosuman merkintä": "search hit marker",
  "hakutulos": "search result",
  "johdos: henkilö löytyi (ennen nimeä)": "lead-in: person found (before the name)",
  "johdos: lauseen alku ennen lihavoitua": "lead-in: start of the sentence before the bold text",
  "johdos: lihavoitu": "lead-in: bold",
  "johdos: lauseen loppu (alkaa kaksoispisteellä)": "lead-in: end of the sentence (starts with a colon)",
  "johdos: vuokra-/alihankintatyöntekijä": "lead-in: agency/subcontracted worker",
  "johdos: ei henkilöstössä (ennen lihavoitua)": "lead-in: not on staff (before the bold text)",
  "johdos: loppu (alkaa kaksoispisteellä)": "lead-in: end (starts with a colon)",
  "selite: ulkopuolisen sallitut roolit": "caption: roles allowed for an external user",
  "näkyvyys": "visibility",
  "näkyvyys; {n}": "visibility; {n}",
  "nappi luonnin aikana": "button while creating",
  "ilmoitus; {nimi} = moduuli": "notice; {nimi} = module",
  "osion otsikko: moduulit": "section heading: modules",
  "osion selite": "section caption",
  "merkintä: pakollinen moduuli": "marker: mandatory module",
  "moduulin tila": "module status",
  "vihje, lihavoitu alku": "hint, bold start",
  "vihje (alkaa pilkulla)": "hint (starts with a comma)",
  "oikeuden laajuus": "permission scope",
  "merkintä oikeusrivillä": "marker on the permission row",
  "oikeuden kohderajaus": "project scope of the permission",
  "vahvistuksen osa": "part of the confirmation",
  "vahvistuksen osa; {tunnukset}": "part of the confirmation; {tunnukset}",
  "vahvistus; {n} {kohde}": "confirmation; {n} {kohde}",
  "ilmoitus; {kieli} {m} {v}": "notice; {kieli} {m} {v}",
  "kielivalinta: organisaation oletus": "language selection: organisation default",
  "ilmoituksen loppu; {n}": "end of the notice; {n}",
  "työmaan lähde: käsin tehty lisäsidonta": "worksite source: manually added assignment",
  "työmaan lähde: allokaatio": "worksite source: allocation",
  "selite; {tila} = kohteen tilatunnus": "caption; {tila} = project status code",
  "työmaasirun merkintä": "worksite chip marker",
  "työmaasirun merkintä; {tila}": "worksite chip marker; {tila}",
  "tuntematon tila": "unknown status",
  "nappi ilman valintaa": "button with nothing selected",
  "nappi; {n}": "button; {n}",
  "kenttätilien luonnin ohje; {n} ehdokasta": "field account creation guidance; {n} candidates",
  "valintojen määrä; {x} {y}": "number of selections; {x} {y}",
  "kertanäytön kohde; {n}": "one-time display item; {n}",
  "kertanäytön vihje": "one-time display hint",
  "nappi ja kertanäytön otsikko": "button and one-time display heading",
  "selite; {n}": "caption; {n}",
  "valintojen määrä; {n}": "number of selections; {n}",
  "aria-label": "aria-label",
  "sarake: kenttätilin koodi": "column: field account code",
  "aria-label; {koodi}": "aria-label; {koodi}",
  "nappi: kenttätilin oikeudet": "button: field account permissions",
  "merkintä isoin kirjaimin": "marker in capitals",
  "kieli: oletus": "language: default",
  "tila: yksikään työmaa ei näy": "status: no worksite visible",
  "tuontipaneelin selite": "import panel caption",
  "tuontipaneelin valintaruutu": "import panel checkbox",
  "lohkon vihje: omien määrä": "block hint: number of own items",
  "sarake: työpäivän pituus": "column: working day length",
  "ryhmäotsikko": "group heading",
  "ryhmäotsikon selite": "group heading caption",
  "hitsaustyön myönnön peruste": "reason for granting welding work",
  "peruste: muu": "reason: other",
  "hitsaustyön peruutuksen peruste": "reason for revoking welding work",
  "peruutuksen peruste": "reason for revocation",
  "laiteasennuksen myönnön peruste": "reason for granting equipment installation",
  "IV-asennuksen myönnön peruste": "reason for granting IV (ventilation) installation",
  "IV-asennuksen peruutuksen peruste": "reason for revoking IV (ventilation) installation",
  "laippatyön myönnön peruste": "reason for granting flange work (flange joint tightening)",
  "laippakiristyksen menetelmä": "flange tightening method (option in the tightening form)",
  "tunnusluku tilaajalle": "key figure shown to the client (neutral, client's point of view)",
  "merkki tilaajalle": "row badge shown to the client (neutral, client's point of view)",
  "otsikko tilaajalle": "heading shown to the client",
  "selite tilaajalle": "explanation shown to the client",
  "laippatyön peruutuksen peruste": "reason for revoking flange work (flange joint tightening)",
  "laiteasennuksen peruutuksen peruste": "reason for revoking equipment installation",
  "peruste: migraation oletus": "reason: migration default",
  "muutoksen laji": "type of change",
  "lippu": "flag",
  "lipun suunta": "flag direction",
  "vahvistus: kpl 1": "confirmation: paragraph 1",
  "vahvistus: kpl 2": "confirmation: paragraph 2",
  "vahvistus: kpl 3": "confirmation: paragraph 3",
  "ohje: alku": "guidance: start",
  "ohje: lihavoitu": "guidance: bold",
  "sarakkeen vihje": "column hint",
  "sarake kapealla": "column on a narrow screen",
  "merkinnän vihje": "marker hint",
  "ruksin vihje": "checkmark hint",
  "ruksin vihje: tallennettu peruste": "checkmark hint: saved reason",
  "paneeli": "panel",
  "paneelin selite": "panel caption",
  "kentän lisä": "field suffix",
  "merkintä rivillä": "marker on the row",
  "merkinnän jatke": "marker continuation",
  "tyhjä solu": "empty cell",
  "solun vihje": "cell hint",
  "tyhjä katto": "empty cap (no limit set)",
  "otsikko ja kenttä": "heading and field",
  "alaotsikko": "subheading",
  "liiteotsikko": "attachment heading",
  "salaisuusikkunan otsikko": "secret dialog heading",
  "salaisuuden selite": "secret caption",
  "tunnuksen laji": "account type",
  "salaisuusikkunan vihje": "secret dialog hint",
  "lähetyksen tulos": "sending result",
  "varateksti": "fallback text",
  "työsuhteen laji": "employment type",
  "viikonpäivän lyhenne": "weekday abbreviation",
  "varastotapahtuman laji": "stock transaction type",
  "nappi synkan aikana": "button while syncing",
  "selite: SP-merkki": "caption: SP badge",
  "nappi / otsikko": "button / heading",
  "Yrityksen tiedot: ilmoitus": "Company details: notice",
  "Yrityksen tiedot: ei oikeutta": "Company details: no permission",
  "Yrityksen tiedot: ohje: kuka muokkaa": "Company details: guidance: who edits",
  "Yrityksen tiedot: ohje: luvut": "Company details: guidance: figures",
  "Yrityksen tiedot: selite": "Company details: caption",
  "Yrityksen tiedot: kenttä": "Company details: field",
  "Yrityksen tiedot: virhe": "Company details: error",
  "Yrityksen tiedot: otsikko": "Company details: heading",
  "Yrityksen tiedot: sertifikaatin voimassaolo": "Company details: certificate validity",
  "Yrityksen tiedot: vahvistus": "Company details: confirmation",
  "Yrityksen tiedot: tyhjä tila": "Company details: empty state",
  "Yrityksen tiedot: kenttä: sertifikaatin myöntäjä": "Company details: field: certificate issuer",
  "Yrityksen tiedot: nappi": "Company details: button",
  "Materiaalikatalogi: nimikeryhmä": "Material catalogue: item group",
  "Materiaalikatalogi: virhe": "Material catalogue: error",
  "Materiaalikatalogi: hakuselitteen yksikkö: «3 / 40 nimikettä»": "Material catalogue: unit in the search caption: «3 / 40 nimikettä»",
  "Materiaalikatalogi: ohje: kuka näkee ja muokkaa": "Material catalogue: guidance: who sees and edits",
  "Materiaalikatalogi: ohje: luvut": "Material catalogue: guidance: figures",
  "Materiaalikatalogi: näkymän otsikko": "Material catalogue: view heading",
  "Materiaalikatalogi: napin selite": "Material catalogue: button caption",
  "Materiaalikatalogi: nappi": "Material catalogue: button",
  "Materiaalikatalogi: otsikko": "Material catalogue: heading",
  "Materiaalikatalogi: luvun perässä: «12 tuotavaa nimikettä»": "Material catalogue: after a number: «12 tuotavaa nimikettä»",
  "Materiaalikatalogi: ohitetut rivit": "Material catalogue: skipped rows",
  "Materiaalikatalogi: selite ennen sarakelistaa": "Material catalogue: caption before the column list",
  "Materiaalikatalogi: sarake: materiaalilaatu": "Material catalogue: column: material grade",
  "Materiaalikatalogi: sarake: yksikkö lyhenteenä": "Material catalogue: column: unit, abbreviated",
  "Materiaalikatalogi: sarake: hinta yksiköltä": "Material catalogue: column: unit price",
  "Materiaalikatalogi: esikatselun rajaus": "Material catalogue: preview limit",
  "Materiaalikatalogi: tyhjä tila": "Material catalogue: empty state",
  "Materiaalikatalogi: hakukentän ohjeteksti": "Material catalogue: search field placeholder text",
  "Materiaalikatalogi: poistonapin selite": "Material catalogue: delete button caption",
  "isometrin tunnistus": "isometric recognition",
  "isometrin tunnistus: nimiö = piirustuksen nimiökenttä": "isometric recognition: nimiö = drawing title block",
  "massatuonnin tiedostovirhe": "bulk import file error",
  "avattava lohko": "expandable block",
  "massatuonnin edistymä": "bulk import progress",
  "yhteenveto: «Kohteessa: 12 kohdistettu · 3 odottaa»": "summary: «Kohteessa: 12 kohdistettu · 3 odottaa»",
  "luettu tieto: «lehti 1/2»": "extracted data: «lehti 1/2»",
  "luettu tieto: «rev B»": "extracted data: «rev B»",
  "kenttä: revisio": "field: revision",
  "esikatselun linjan tila": "line status in the preview",
  "napin jatko": "button continuation",
  "pudotusalue, lihavoitu": "drop zone, bold",
  "pudotusalue": "drop zone",
  "tiedoston muoto": "file format",
  "koontiruutu": "summary tile",
  "linjaehdotus": "line suggestion",
  "solun title": "cell title",
  "solun merkintä": "cell marker",
  "nappi: osien määrä": "button: number of parts",
  "sarake: positio": "column: position",
  "poistettu rivi: «poisti Toni»": "deleted row: «poisti Toni»",
  "kutsulinkki: virhe": "invitation link: error",
  "kutsulinkki: lataus": "invitation link: loading",
  "kutsulinkki: otsikko": "invitation link: heading",
  "linkki kirjautumissivulle": "link to the sign-in page",
  "kutsulinkki: valmis": "invitation link: done",
  "otsikko / selite": "heading / caption",
  "otsikko / nappi": "heading / button",
  "kutsulinkki: ohje": "invitation link: guidance",
  "kutsulinkki: vihje": "invitation link: hint",
  "estosivun teksti": "access-denied page text",
  "estosivun teksti: ei rooleja": "access-denied page text: no roles",
  "valikkonapin nimi (aria)": "menu button name (aria)",
  "lukemattomat viestit (aria)": "unread messages (aria)",
  "nimeämätön resurssi": "unnamed resource",
  "huomioitavaa: vaje": "attention: shortfall",
  "huomioitavaa: vuokratyö": "attention: agency work",
  "huomioitavaa: ristiriita": "attention: conflict",
  "huomioitavaa: ylitys": "attention: overrun",
  "huomioitavaa: ylitys (jatkuu)": "attention: overrun (continues)",
  "huomioitavaa: ylitys (jatkoa)": "attention: overrun (continued)",
  "huomioitavaa: kuukausiylitys": "attention: monthly overrun",
  "yläotsikko: viikkoväli": "top heading: week range",
  "rekisteririvi": "register row",
  "saavutettavuus": "accessibility",
  "viikkokortti": "week card",
  "sarake: viikko": "column: week",
  "suodin: kaikki osaamiset": "filter: all skills",
  "tarkkuus": "precision",
  "värin selite": "colour legend",
  "huomautus (jatkuu)": "note (continues)",
  "huomautus (jatkoa)": "note (continued)",
  "aikataulu": "schedule",
  "aikataulun rivi": "schedule row",
  "ikkunan otsikko": "dialog heading",
  "varoitus (jatkoa)": "warning (continued)",
  "tarpeen henkilömäärä": "headcount of the need",
  "tarpeen vaatimukset (yksi)": "requirements of the need (one)",
  "tarpeen vaatimukset (monta)": "requirements of the need (several)",
  "tarpeen vaatimukset": "requirements of the need",
  "estelaatikon selite": "blocker box caption",
  "estelaatikon rivi": "blocker box row",
  "kohdetieto": "project information",
  "ohje: kuka saa tehdä mitä": "guidance: who may do what",
  "sarake ja kenttä: kohteen tunnus": "column and field: project code",
  "sarake, kenttä ja otsikko": "column, field and heading",
  "sarake ja kenttä: kohteen laji (projekti/jatkuva)": "column and field: project type (project/ongoing)",
  "nappi: aikajana tähän viikkoon": "button: move the timeline to this week",
  "aikajanan palkin title; {tunnus}, {n} henkilöä, {h} tuntia": "timeline bar title; {tunnus}, {n} people, {h} hours",
  "summarivi": "total row",
  "title": "title",
  "tyhjä aikajana": "empty timeline",
  "tarjokkaan eräpäivä puuttuu": "candidate's due date missing",
  "eräpäivä; {n} pv, {pvm}": "due date; {n} days, {pvm}",
  "eräpäivä; {pvm}": "due date; {pvm}",
  "eräpäivä; {pvm}, {n} pv": "due date; {pvm}, {n} days",
  "tarjokkaan tila": "candidate status",
  "ilmoitus; {n} vaatimuksen luku, {m} tarve": "notice; {n} = number of requirements, {m} = need",
  "ilmoitus; {n} vaatimusta": "notice; {n} requirements",
  "vahvistus; {n} × {luokka}": "confirmation; {n} × {luokka}",
  "vahvistus, jatko; {n}": "confirmation, continuation; {n}",
  "ilmoitus; {nimi}": "notice; {nimi}",
  "ilmoitus; {n} viikkoa": "notice; {n} weeks",
  "ilmoitus; {nimi}, {n}": "notice; {nimi}, {n}",
  "jakson loppu puuttuu": "period end missing",
  "vahvistus; {nimi} {vali}": "confirmation; {nimi} {vali}",
  "vahvistus, jatko": "confirmation, continuation",
  "ilmoitus; {nimi} {vali} {n}": "notice; {nimi} {vali} {n}",
  "vahvistus; {nimi}, {n} × {luokka}": "confirmation; {nimi}, {n} × {luokka}",
  "merkintä; {tunnus}": "marker; {tunnus}",
  "kohteen laji": "project type",
  "korjauksen syy": "correction reason",
  "korjauksen syy (223, T468)": "correction reason (223, T468)",
  "kohteen asetus (221, T464)": "project setting (221, T464)",
  "kohteen asetus (222, T466)": "project setting (222, T466)",
  "kielen nimi": "language name",
  "siru; {a} / {n}": "chip; {a} / {n}",
  "siru; {n}": "chip; {n}",
  "teksti; {n} / {m}": "text; {n} / {m}",
  "siru; {n} / {m}": "chip; {n} / {m}",
  "title; {nimi}": "title; {nimi}",
  "kenttä; {n}": "field; {n}",
  "vihje; {n}": "hint; {n}",
  "rivi; {nimi} {pv} {h}": "row; {nimi} {pv} {h}",
  "esteen selite": "blocker caption",
  "esteen puute": "blocker: missing item",
  "teksti ennen päivämääriä": "text before the dates",
  "nappi: pura sidonta": "button: remove the assignment",
  "nappi: avaa sidontalomakkeen": "button: opens the assignment form",
  "rivin alku": "start of the row",
  "puutteen syy": "issue reason",
  "puutteen syy; {pvm}": "issue reason; {pvm}",
  "rivi; {lista}": "row; {lista}",
  "teksti; {pvm}": "text; {pvm}",
  "teksti: tähän tarpeeseen": "text: to this need",
  "teksti; {kohde}": "text; {kohde}",
  "teksti; {n}": "text; {n}",
  "teksti; {peruste}": "text; {peruste}",
  "valinta, ennen päivämääriä": "selection, before the dates",
  "kenttä: työpäivän pituus": "field: working day length",
  "nappi; {n} > 1": "button; {n} > 1",
  "teksti; {n} osaajaa, {v} vapaana": "text; {n} skilled workers, {v} available",
  "teksti ennen listaa": "text before the list",
  "placeholder: esimerkkinimi": "placeholder: example name",
  "teksti; {teksti}": "text; {teksti}",
  "kenttä: asiakkaan rooli kohteessa": "field: customer's role in the project",
  "placeholder: esimerkkiyritys": "placeholder: example company",
  "vahvistus; {nimi}": "confirmation; {nimi}",
  "merkki; {n}": "badge; {n}",
  "sarake: ensimmäinen työpäivä": "column: first working day",
  "merkki; {pvm}": "badge; {pvm}",
  "kenttä: perehdytyksen alue": "field: induction area",
  "vahvistus; {laji}": "confirmation; {laji}",
  "ilmoitus; {vanha} → {uusi}": "notice; {vanha} → {uusi}",
  "ilmoitus; {uusi} {vanha}": "notice; {uusi} {vanha}",
  "Tarjousasetukset: TES-lisän laji": "Offer settings: TES supplement type",
  "Tarjousasetukset: sivukulun suuruusluokkavihje: TyEL": "Offer settings: side-cost magnitude hint: TyEL",
  "Tarjousasetukset: sivukulun vihje: sairausvakuutusmaksu": "Offer settings: side-cost hint: health insurance contribution",
  "Tarjousasetukset: sivukulun vihje: työttömyysvakuutus": "Offer settings: side-cost hint: unemployment insurance",
  "Tarjousasetukset: sivukulun vihje: tapaturmavakuutus": "Offer settings: side-cost hint: accident insurance",
  "Tarjousasetukset: sivukulun vihje: lomapalkka": "Offer settings: side-cost hint: holiday pay",
  "Tarjousasetukset: sivukulun vihje: arkipyhät": "Offer settings: side-cost hint: weekday public holidays",
  "Tarjousasetukset: lukukentän tila: arvo ei kelpaa": "Offer settings: numeric field state: invalid value",
  "Tarjousasetukset: näkymän otsikko": "Offer settings: view heading",
  "Tarjousasetukset: alaotsikko": "Offer settings: subheading",
  "Tarjousasetukset: ohje: kuka muokkaa": "Offer settings: guidance: who edits",
  "Tarjousasetukset: ohje: luvut": "Offer settings: guidance: figures",
  "Tarjousasetukset: lohkon otsikko": "Offer settings: block heading",
  "Tarjousasetukset: lohkon selite": "Offer settings: block caption",
  "Tarjousasetukset: kenttä: luvun vuosi": "Offer settings: field: year of the figure",
  "Tarjousasetukset: kentän ohjeteksti": "Offer settings: field placeholder text",
  "Tarjousasetukset: linkki": "Offer settings: link",
  "Tarjousasetukset: summarivi ja tunnusluku": "Offer settings: total row and key figure",
  "Tarjousasetukset: huomautus, alku": "Offer settings: note, start",
  "Tarjousasetukset: huomautus, lihavoitu": "Offer settings: note, bold",
  "Tarjousasetukset: huomautus, loppu": "Offer settings: note, end",
  "Tarjousasetukset: ohje, alku: «Syötä raakapalkka €/h, ei…»": "Offer settings: guidance, start: «Syötä raakapalkka €/h, ei…»",
  "Tarjousasetukset: ohje, lihavoitu": "Offer settings: guidance, bold",
  "Tarjousasetukset: ohje, loppu (alkaa pilkulla)": "Offer settings: guidance, end (starts with a comma)",
  "Tarjousasetukset: sarake": "Offer settings: column",
  "Tarjousasetukset: yksikkö": "Offer settings: unit",
  "Tarjousasetukset: tyhjä tila": "Offer settings: empty state",
  "Tarjousasetukset: asetus": "Offer settings: setting",
  "Tarjousasetukset: asetuksen selite": "Offer settings: setting caption",
  "Tarjousasetukset: yksikkö: vuorokausi": "Offer settings: unit: day (24 h)",
  "Tarjousasetukset: esimerkki": "Offer settings: example",
  "Tarjousasetukset: tunnusluvun selite": "Offer settings: key figure caption",
  "Tarjousasetukset: virhe": "Offer settings: error",
  "Tarjousasetukset: nappi": "Offer settings: button",
  "Tarjousasetukset: sarake ja kenttä": "Offer settings: column and field",
  "Tarjousasetukset: sarake: hitsausprosessi": "Offer settings: column: welding process",
  "Tarjousasetukset: normirivi ilman prosessia": "Offer settings: norm row without a process",
  "Tarjousasetukset: napin selite": "Offer settings: button caption",
  "Tarjousasetukset: TES ei aktiivinen": "Offer settings: TES not active",
  "Tarjousasetukset: lisän voimaantulo": "Offer settings: supplement effective date",
  "Tarjousasetukset: kenttä": "Offer settings: field",
  "Tarjousasetukset: jaksohistorian otsikko": "Offer settings: period history heading",
  "Tarjousasetukset: TES-PDF-tuonnin ohje": "Offer settings: TES PDF import guidance",
  "Tarjousasetukset: lataustila": "Offer settings: upload status",
  "Tarjousasetukset: merkin selite": "Offer settings: badge caption",
  "Tarjousasetukset: poiminnan varmuus": "Offer settings: extraction confidence",
  "Tarjous: tarjouksen tila": "Offer: offer status",
  "Tarjous: kustannusrakenteen osa": "Offer: cost structure component",
  "Tarjous: kustannusrakenteen osa: matkat ja päivärahat": "Offer: cost structure component: travel and daily allowances",
  "Tarjous: kustannusrakenteen osa ja yhteenvedon rivi": "Offer: cost structure component and summary row",
  "Tarjous: tulospaneelin otsikko (isoilla)": "Offer: results panel heading (in capitals)",
  "Tarjous: hinnan perässä": "Offer: after the price",
  "Tarjous: tulospaneelin selite": "Offer: results panel caption",
  "Tarjous: erien määrä": "Offer: number of batches",
  "Tarjous: tulospaneeli": "Offer: results panel",
  "Tarjous: tunnusluku": "Offer: key figure",
  "Tarjous: tunnusluku: hinta / kustannus": "Offer: key figure: price / cost",
  "Tarjous: nappi": "Offer: button",
  "Tarjousdokumentti (tuloste asiakkaalle): otsikko": "Offer document (printout for the customer): heading",
  "Tarjousdokumentti (tuloste asiakkaalle): osapuoli": "Offer document (printout for the customer): party",
  "Tarjousdokumentti (tuloste asiakkaalle): y-tunnus": "Offer document (printout for the customer): business ID",
  "Tarjousdokumentti (tuloste asiakkaalle): myyjä": "Offer document (printout for the customer): seller",
  "Tarjous: tilaaja (myös tulosteessa)": "Offer: client (also in the printout)",
  "Tarjousdokumentti (tuloste asiakkaalle): toteutusaika": "Offer document (printout for the customer): execution period",
  "Tarjous: kenttä ja sarake": "Offer: field and column",
  "Tarjousdokumentti (tuloste asiakkaalle): sarake": "Offer document (printout for the customer): column",
  "Tarjous: yhteenvedon rivi (myös tulosteessa)": "Offer: summary row (also in the printout)",
  "Tarjousdokumentti (tuloste asiakkaalle): alv-huomautus": "Offer document (printout for the customer): VAT note",
  "Tarjousdokumentti (tuloste asiakkaalle): ehto": "Offer document (printout for the customer): term",
  "Tarjousdokumentti (tuloste asiakkaalle): sertifikaattilista": "Offer document (printout for the customer): certificate list",
  "Tarjousdokumentti (tuloste asiakkaalle): alaviite": "Offer document (printout for the customer): footnote",
  "Tarjous: ohje: kuka näkee ja muokkaa": "Offer: guidance: who sees and edits",
  "Tarjous: ohje: luvut": "Offer: guidance: figures",
  "Tarjous: tyhjä tila": "Offer: empty state",
  "Tarjous: virhe": "Offer: error",
  "Tarjous: kenttä": "Offer: field",
  "Tarjous: valinta": "Offer: selection",
  "Tarjous: paluunappi": "Offer: back button",
  "Tarjous: lohkon otsikko": "Offer: block heading",
  "Tarjous: erän merkintä": "Offer: batch marker",
  "Tarjous: puuttuva tieto": "Offer: missing information",
  "Tarjous: kentän ohjeteksti: normi normitaulukosta": "Offer: field placeholder text: norm from the norm table",
  "Tarjous: kenttä: osaamisluokka": "Offer: field: trade",
  "Tarjous: kenttä: katalogin nimike": "Offer: field: catalogue item",
  "Tarjous: valinnan vaihtoehto": "Offer: selection option",
  "Tarjous: kentän ohjeteksti": "Offer: field placeholder text",
  "Tarjous: vihje": "Offer: hint",
  "Tarjous: otsikko ja yhteenvedon rivi": "Offer: heading and summary row",
  "Tarjous: kenttä: työehtosopimus": "Offer: field: collective agreement",
  "Tarjous: vuoro-osuus": "Offer: shift share",
  "Tarjous: vuoro-osuus: lauantai": "Offer: shift share: Saturday",
  "Tarjous: vuoro-osuus: sunnuntai": "Offer: shift share: Sunday",
  "Tarjous: vuoro-osuus: ylityö 50 %": "Offer: shift share: overtime 50 %",
  "Tarjous: vuoro-osuus: ylityö 100 %": "Offer: shift share: overtime 100 %",
  "Tarjous: otsikko": "Offer: heading",
  "Tarjous: yhteenvedon rivi": "Offer: summary row",
  "Tarjous: henkilöstökustannuksen kaava": "Offer: staff cost formula",
  "Tarjous: selite": "Offer: caption",
  "Tarjous: laskentakaavan selitys": "Offer: explanation of the calculation formula",
  "estosivun selitys, Academy": "access-denied page explanation, Academy",
  "henkilökortti, kenttätilin Academy-oikeus": "person card, field account Academy permission",
  "nappi, henkilökortti": "button, person card",
  "virhe, henkilökortti": "error, person card",
  "tilasana, Selailu": "status word, Browse",
  "nappi, hitsirivi": "button, weld row",
  "nappi ja otsikko": "button and heading",
  "kenttä, poistoesityksen ratkaisu": "field, decision on a deletion proposal",
  "moduuli-taulun nimi (kannasta, tunnus henkilot)": "module table name (from the database, code henkilot)",
  "moduuli-taulun kuvaus (kannasta, tunnus henkilot)": "module table description (from the database, code henkilot)",
  "moduuli-taulun nimi (kannasta, tunnus hitsausloki)": "module table name (from the database, code hitsausloki)",
  "moduuli-taulun kuvaus (kannasta, tunnus hitsausloki)": "module table description (from the database, code hitsausloki)",
  "moduuli-taulun nimi (kannasta, tunnus iv_asennus)": "module table name (from the database, code iv_asennus)",
  "moduuli-taulun nimi (kannasta, tunnus laippaliitokset)": "module table name (from the database, code laippaliitokset)",
  "moduuli-taulun kuvaus (kannasta, tunnus laippaliitokset)": "module table description (from the database, code laippaliitokset)",
  "moduuli-taulun kuvaus (kannasta, tunnus iv_asennus)": "module table description (from the database, code iv_asennus)",
  "moduuli-taulun nimi (kannasta, tunnus kalusto)": "module table name (from the database, code kalusto)",
  "moduuli-taulun kuvaus (kannasta, tunnus kalusto)": "module table description (from the database, code kalusto)",
  "moduuli-taulun nimi (kannasta, tunnus kayttajat)": "module table name (from the database, code kayttajat)",
  "moduuli-taulun kuvaus (kannasta, tunnus kayttajat)": "module table description (from the database, code kayttajat)",
  "moduuli-taulun nimi (kannasta, tunnus kohteet)": "module table name (from the database, code kohteet)",
  "moduuli-taulun kuvaus (kannasta, tunnus kohteet)": "module table description (from the database, code kohteet)",
  "moduuli-taulun nimi (kannasta, tunnus laiteasennus)": "module table name (from the database, code laiteasennus)",
  "moduuli-taulun kuvaus (kannasta, tunnus laiteasennus)": "module table description (from the database, code laiteasennus)",
  "moduuli-taulun nimi (kannasta, tunnus liitteet)": "module table name (from the database, code liitteet)",
  "moduuli-taulun kuvaus (kannasta, tunnus liitteet)": "module table description (from the database, code liitteet)",
  "moduuli-taulun nimi (kannasta, tunnus mitoitus)": "module table name (from the database, code mitoitus)",
  "moduuli-taulun kuvaus (kannasta, tunnus mitoitus)": "module table description (from the database, code mitoitus)",
  "moduuli-taulun nimi (kannasta, tunnus osaaminen)": "module table name (from the database, code osaaminen)",
  "moduuli-taulun kuvaus (kannasta, tunnus osaaminen)": "module table description (from the database, code osaaminen)",
  "moduuli-taulun nimi (kannasta, tunnus patevyydet)": "module table name (from the database, code patevyydet)",
  "moduuli-taulun kuvaus (kannasta, tunnus patevyydet)": "module table description (from the database, code patevyydet)",
  "moduuli-taulun nimi (kannasta, tunnus poissaolot)": "module table name (from the database, code poissaolot)",
  "moduuli-taulun kuvaus (kannasta, tunnus poissaolot)": "module table description (from the database, code poissaolot)",
  "moduuli-taulun nimi (kannasta, tunnus puutteet)": "module table name (from the database, code puutteet)",
  "moduuli-taulun kuvaus (kannasta, tunnus puutteet)": "module table description (from the database, code puutteet)",
  "moduuli-taulun nimi (kannasta, tunnus resurssit)": "module table name (from the database, code resurssit)",
  "moduuli-taulun kuvaus (kannasta, tunnus resurssit)": "module table description (from the database, code resurssit)",
  "moduuli-taulun nimi (kannasta, tunnus tarjous)": "module table name (from the database, code tarjous)",
  "moduuli-taulun kuvaus (kannasta, tunnus tarjous)": "module table description (from the database, code tarjous)",
  "oikeus-taulun nimi (kannasta, tunnus academy)": "permission table name (from the database, code academy)",
  "oikeus-taulun kuvaus (kannasta, tunnus academy)": "permission table description (from the database, code academy)",
  "oikeus-taulun nimi (kannasta, tunnus ainestodistukset_luku)": "permission table name (from the database, code ainestodistukset_luku)",
  "oikeus-taulun kuvaus (kannasta, tunnus ainestodistukset_luku)": "permission table description (from the database, code ainestodistukset_luku)",
  "oikeus-taulun nimi (kannasta, tunnus arkaluonteiset_henkilotiedot)": "permission table name (from the database, code arkaluonteiset_henkilotiedot)",
  "oikeus-taulun kuvaus (kannasta, tunnus arkaluonteiset_henkilotiedot)": "permission table description (from the database, code arkaluonteiset_henkilotiedot)",
  "oikeus-taulun nimi (kannasta, tunnus hitsausloki_tyonjohto)": "permission table name (from the database, code hitsausloki_tyonjohto)",
  "oikeus-taulun kuvaus (kannasta, tunnus hitsausloki_tyonjohto)": "permission table description (from the database, code hitsausloki_tyonjohto)",
  "oikeus-taulun nimi (kannasta, tunnus kaannostarkistus)": "permission table name (from the database, code kaannostarkistus)",
  "oikeus-taulun kuvaus (kannasta, tunnus kaannostarkistus)": "permission table description (from the database, code kaannostarkistus)",
  "oikeus-taulun nimi (kannasta, tunnus kaannosten_hyvaksynta)": "permission table name (from the database, code kaannosten_hyvaksynta)",
  "oikeus-taulun kuvaus (kannasta, tunnus kaannosten_hyvaksynta)": "permission table description (from the database, code kaannosten_hyvaksynta)",
  "oikeus-taulun nimi (kannasta, tunnus kalustovastaava)": "permission table name (from the database, code kalustovastaava)",
  "oikeus-taulun kuvaus (kannasta, tunnus kalustovastaava)": "permission table description (from the database, code kalustovastaava)",
  "oikeus-taulun nimi (kannasta, tunnus osaaminen_arviointi)": "permission table name (from the database, code osaaminen_arviointi)",
  "oikeus-taulun kuvaus (kannasta, tunnus osaaminen_arviointi)": "permission table description (from the database, code osaaminen_arviointi)",
  "oikeus-taulun nimi (kannasta, tunnus osaaminen_nimitys)": "permission table name (from the database, code osaaminen_nimitys)",
  "oikeus-taulun kuvaus (kannasta, tunnus osaaminen_nimitys)": "permission table description (from the database, code osaaminen_nimitys)",
  "oikeus-taulun nimi (kannasta, tunnus osaaminen_rajat)": "permission table name (from the database, code osaaminen_rajat)",
  "oikeus-taulun kuvaus (kannasta, tunnus osaaminen_rajat)": "permission table description (from the database, code osaaminen_rajat)",
  "oikeus-taulun nimi (kannasta, tunnus perehdytykset_luku)": "permission table name (from the database, code perehdytykset_luku)",
  "oikeus-taulun kuvaus (kannasta, tunnus perehdytykset_luku)": "permission table description (from the database, code perehdytykset_luku)",
  "oikeus-taulun nimi (kannasta, tunnus hitsauskoordinointi)": "permission table name (from the database, code hitsauskoordinointi)",
  "oikeus-taulun kuvaus (kannasta, tunnus hitsauskoordinointi)": "permission table description (from the database, code hitsauskoordinointi)",
  "oikeus-taulun nimi (kannasta, tunnus materiaalit)": "permission table name (from the database, code materiaalit)",
  "oikeus-taulun kuvaus (kannasta, tunnus materiaalit)": "permission table description (from the database, code materiaalit)",
  "oikeus-taulun nimi (kannasta, tunnus punakyna_hyvaksynta)": "permission table name (from the database, code punakyna_hyvaksynta)",
  "oikeus-taulun kuvaus (kannasta, tunnus punakyna_hyvaksynta)": "permission table description (from the database, code punakyna_hyvaksynta)",
  "oikeus-taulun nimi (kannasta, tunnus punch_poikkeama)": "permission table name (from the database, code punch_poikkeama)",
  "oikeus-taulun kuvaus (kannasta, tunnus punch_poikkeama)": "permission table description (from the database, code punch_poikkeama)",
  "oikeus-taulun nimi (kannasta, tunnus viestin_lahetys)": "permission table name (from the database, code viestin_lahetys)",
  "oikeus-taulun kuvaus (kannasta, tunnus viestin_lahetys)": "permission table description (from the database, code viestin_lahetys)",
  "vastuu-suodattimen arvo": "responsibility filter value",
  "vastuu-suodattimen arvo: käsin kirjoitettu vastuu": "responsibility filter value: manually entered responsibility",
  "valikon kohta (vain demo)": "menu item (demo only)",
  "ohjeen kieliversio puuttuu": "guide language version missing",
  "kielen nimi lauseessa": "language name within a sentence",
  "valikkoryhmä: ohjeet ja testaus (aina auki, kaikille rooleille)": "menu group: guides and testing (always open, for all roles)",
  "valikon kohta (vain demo, pääkäyttäjä)": "menu item (demo only, administrator)",
  "yläpalkin «?»-linkin nimi": "name of the top-bar «?» link",
  "Testaus-näkymän osio": "Testing view section",
  "rivin merkintä: testaaja on avannut": "row marker: tester has opened it",
  "pääkäyttäjän osio": "administrator section",
  "ilmoituksen tila": "notice status",
  "rivimäärä": "row count",
  "kiinteä Palaute-nappi (kaikki sivut, selaintunnukset)": "fixed Feedback button (every page, browser accounts)",
  "sivun avautuessa haettavan listan lataus": "loading a list when a page opens",
  "Palaute-ikkunan otsikko": "Feedback dialog heading",
  "Palaute-ikkunan sulkunappi (×)": "Feedback dialog close button (×)",
  "Palaute-ikkunan peruutus": "Feedback dialog cancel",
  "Palaute-ikkunan lähetysnappi": "Feedback dialog send button",
  "palautteen tyyppivalinta": "feedback type selection",
  "palautteen tyyppi": "feedback type",
  "palautteen tekstikenttä": "feedback text field",
  "testaajan nimikirjaimet (yhteiskäyttötunnus)": "tester's initials (shared account)",
  "nimikirjainten esimerkki": "initials example",
  "nimikirjainten selitys": "initials explanation",
  "testausohjeen alun ohje": "guidance at the start of the testing guide",
  "tehtävän valintaryhmän nimi ruudunlukijalle": "task option group name for screen readers",
  "tehtävän tulos": "task result",
  "tehtävän kommenttikenttä": "task comment field",
  "tallennuskuittaus": "save acknowledgement",
  "loppukysymysten otsikko": "final questions heading",
  "loppukysymys": "final question",
  "loppukysymys 1–5": "final question 1–5",
  "perustelun esimerkki": "example of a justification",
  "laite": "device",
  "palaute lähetetty": "feedback sent",
  "palautteen näkyvyys": "feedback visibility",
  "pääkäyttäjän näkymän otsikko": "administrator view heading",
  "suodattimen oletus": "filter default",
  "palautteen laji": "feedback category",
  "sarake: tunnuskoodi ja nimikirjaimet": "column: account code and initials",
  "roolivalitsimen otsikko (pääkäyttäjä)": "role selector heading (administrator)",
  "roolivalitsimessa: roolille ei ole vielä ohjetta": "in the role selector: no guide for the role yet",
  "kun roolin ohjetta ei ole kirjoitettu": "when the role's guide has not been written",
  "linkki demon testausohjeeseen": "link to the demo testing guide",
  "rooli": "role",
  "tulosteen taulukon otsikko": "printout table heading",
  "oikeusnäkymä (T530): paketit ja erilliset oikeudet": "rights view (T530): packages and separate rights",
  "liitteen lisäysnappi": "attachment add button",
  "työpaketti: tilan siirto taaksepäin (T520)": "work package: status moving backwards (T520)",
  "työpaketti: suunnitellut päivät (T520)": "work package: planned dates (T520)",
  "linjan valmiusilmoitus (T520)": "line readiness report (T520)",
  "tehtävän hoitaja (T534)": "task handler (T534)",
  "tarrahistoria (T566)": "sticker history (T566)",
  "Hubin puutejono (T567)": "Hub issue queue (T567)",
  "omat tehtävät (T534)": "my tasks (T534)",
  "kolmen viikon suunnitelma (T373)": "three-week plan (T373)",
  "punchin ja puutteen vapaatekstin ohje": "guidance under the punch and issue free-text field",
  "työpaketin arkistointi (238)": "work package archiving (238)",
  "puutteet: kattavuusrivin avaus": "issues: coverage row disclosure",
  "hitsauslokin kenttävirhe": "weld log field error",
  "NDT/VT-pöytäkirjan liite (T562)": "NDT/VT report attachment (T562)",
  "liitteen lisäysohje": "attachment add hint",
  "oikeusnäkymä (T530): mitä pelkän roolin paketti antaa (ⓘ)": "rights view (T530): what a role-only package gives (ⓘ)",
  "oikeuspaketin nimi (T530)": "rights package name (T530)",
  "oikeuspaketin kuvaus (T530)": "rights package description (T530)",
  "oikeusryhmän otsikko (T530)": "rights group heading (T530)",
  "tunnuseditorin yläosa (T530 tiivistys)": "account editor top (T530 compaction)",
  "valikon esto: pätevyyksien lukuoikeus puuttuu": "menu block: the right to read qualifications is missing",
  "valintaruutu: liite arkaluonteiseksi käsin": "checkbox: mark an attachment as sensitive by hand",
  "oikeus-taulun nimi (kannasta, tunnus tg_hyvaksynta)": "permission table name (from the database, code tg_hyvaksynta)",
  "oikeus-taulun kuvaus (kannasta, tunnus tg_hyvaksynta)": "permission table description (from the database, code tg_hyvaksynta)",
  "oikeus-taulun nimi (kannasta, tunnus tg_maaraaika)": "permission table name (from the database, code tg_maaraaika)",
  "oikeus-taulun kuvaus (kannasta, tunnus tg_maaraaika)": "permission table description (from the database, code tg_maaraaika)",
  "oikeus-taulun nimi (kannasta, tunnus tg_nakyma)": "permission table name (from the database, code tg_nakyma)",
  "oikeus-taulun kuvaus (kannasta, tunnus tg_nakyma)": "permission table description (from the database, code tg_nakyma)",
  "estosivun selitys, kohteen portit (TG)": "explanation on the blocked page, project gates (TG)",
  "oikeus-taulun nimi (kannasta, tunnus patevyydet_luku)":"permission table name (from the database, code patevyydet_luku)",
  "oikeus-taulun kuvaus (kannasta, tunnus patevyydet_luku)": "permission table description (from the database, code patevyydet_luku)",
  "nappi: merkitse liite arkaluonteiseksi": "button: mark an attachment as sensitive",
  "nappi: poista arkaluonteinen-merkintä": "button: remove the sensitive mark",
  "ilmoitus: liite merkitty arkaluonteiseksi": "notice: attachment marked as sensitive",
  "ilmoitus: arkaluonteinen-merkintä poistettu": "notice: sensitive mark removed",
  "havaintosäännön kuvaus (puutelista)": "detection rule description (issue list)",
  "liitteen laji: valinta": "attachment type: selector",
  "liitteen laji: tavallinen": "attachment type: ordinary",
  "liitteen laji: allekirjoitettu pöytäkirja": "attachment type: signed record",
  "liitteen laji: piirretty allekirjoitus": "attachment type: drawn signature",
  "kuvan laji: kuvaus": "photo type: description",
  "hitsin huomio: otsake rivillä": "weld note: label on the row",
  "kuvan laji: sijainti": "photo type: location",
  "kuvan laji: sijainti 3D-mallissa": "photo type: location in the 3D model",
  "kuvan laji: ei valittu": "photo type: not selected",
  "kuvan laji: valinta": "photo type: selector",
  "kuvan nimi: kenttä": "photo name: field",
  "kuvan nimi: kentän vihje": "photo name: field placeholder",
  "kuvan nimeäminen: nappi": "photo naming: button",
  "kuvan nimeäminen: tallenna": "photo naming: save",
  "kuvan nimeäminen: peru": "photo naming: cancel",
  "kuvan nimeäminen: tallennettu": "photo naming: saved",
  "kuvan nimeäminen: alkuperäinen tiedostonimi vihjeenä": "photo naming: original file name as a tooltip",
  "liitteen lisäys galleriasta": "add attachment from the gallery",
  "linjatarkastus: asiakkaan edustajan allekirjoitus": "line inspection: client representative's signature",
  "linjatarkastuksen kohdan tallennuksen tila": "line inspection item: save status shown next to the item",
  "linjatarkastuksen kohdan uusi tallennusyritys": "line inspection item: retry saving after a failure",
  "linjatarkastusraportti": "line inspection report (printed A4 document): headings, labels and sentences",
  "linjatarkastuksen kohdan 7.2 VT-peruste":"line inspection item 7.2: reason field when visual testing is missing on welded welds",
  "hyväksynnän este: VT puuttuu ilman perustetta": "approval blocker: item 7.2 OK while visual testing is missing, no reason given",
  "näkyvyys: ulkopuolisen kohde pakollinen": "visibility: an external account must be bound to at least one Project",
  "valikon kohta: kohteen portit (TG, tollgate)": "menu item: the Project's gates (TG, tollgate)",
  "porttinäkymän selite": "gates view explanation",
  "portin tila": "gate state",
  "porttien yhteenveto; {n} hyväksyttyä, {m} kaikkiaan": "gates summary; {n} approved, {m} in total",
  "porttien yhteenveto: seuraava avoin portti": "gates summary: next open gate",
  "porttinäkymä tyhjänä": "gates view when empty",
  "porttinäkymä tyhjänä, käyttäjä saa luoda": "gates view when empty, user may create",
  "porttinuolen saavutettava nimi": "accessible name of the gates arrow",
  "portin määräaika": "gate deadline",
  "portin hyväksyjä; {kuka} nimi, {milloin} aika": "gate approver; {kuka} name, {milloin} time",
  "kenttä: vapaaehtoinen peruste": "field: optional reason",
  "nappi: hyväksy portti": "button: approve gate",
  "ilmoitus: portti hyväksytty; {tunnus}": "notice: gate approved; {tunnus}",
  "kenttä: portin uusi määräaika": "field: new gate deadline",
  "nappi: siirrä portin määräaika": "button: move gate deadline",
  "ilmoitus: määräaika siirretty; {tunnus}": "notice: deadline moved; {tunnus}",
  "porttinäkymä ilman oikeuksia": "gates view without rights",
  "portin tapahtumaloki: otsikko": "gate event log: heading",
  "portin tapahtumaloki: sarake": "gate event log: column",
  "portin tapahtuman laji": "gate event type",
  "ilmoitus: portti lisätty; {tunnus}": "notice: gate added; {tunnus}",
  "kenttä: portin tunnus": "field: gate code",
  "kenttä: portin nimi": "field: gate name",
  "nappi: lisää portti": "button: add gate",
  "virhe: portin hyväksyntäoikeus puuttuu": "error: no right to approve the gate",
  "virhe: portin siirto-oikeus puuttuu": "error: no right to move the gate deadline",
  "portin tehtävät: otsikko": "gate tasks: heading",
  "portin tehtävät tehty; {n} tehty, {m} kaikkiaan": "gate tasks done; {n} done, {m} in total",
  "portin tehtävät: tyhjä": "gate tasks: empty",
  "portin tila: lukittu": "gate state: locked",
  "portin lukituksen syy; {portit} aiemmat portit tekemättömine tehtävineen": "reason the gate is locked; {portit} earlier gates with open tasks",
  "hyväksynnän este; {n} tekemätöntä tehtävää": "approval blocker; {n} open tasks",
  "ilmoitus: tehtävä merkitty tehdyksi": "notice: task marked done",
  "ilmoitus: tehtävä avattu uudelleen": "notice: task reopened",
  "tehtävän kuittaaja; {kuka} nimi, {milloin} aika": "who completed the task; {kuka} name, {milloin} time",
  "kenttä: uusi tehtävä portille": "field: new task for the gate",
  "nappi: lisää tehtävä": "button: add task",
  "ilmoitus: tehtävä lisätty": "notice: task added",
  "virhe: portti lukittu aiempien tehtävien takia": "error: gate locked because of earlier open tasks",
  "virhe: portin tehtäviä kesken": "error: the gate has open tasks",
  "virhe: portti on jo hyväksytty":"error: gate already approved",
  "virhe: uusi määräaika sama kuin vanha": "error: new deadline equals the old one",
  "virhe: ulkopuolinen ilman kohdetta":"error: external account created without a Project",
  "virhe: VT-peruste puuttuu":"error: item 7.2 marked OK without a reason while visual testing is missing",
  "linjatarkastus: allekirjoitusruudun ohje": "line inspection: signature pad hint",
  "linjatarkastus: allekirjoitusruudun tyhjennys": "line inspection: clear the signature pad",
  "hyväksynnän este: allekirjoitus puuttuu (251)": "approval blocker: signature missing (251)",
  "linjatarkastus: allekirjoituksen tiedot": "line inspection: signature details",
  "linjatarkastus: allekirjoitettu paperipöytäkirja liitteenä": "line inspection: signed paper record attached",
  "linjatarkastus: tarkastuskuvien osio": "line inspection: inspection photos section",
  "linjatarkastus: tarkastuskuvan lisäysnappi": "line inspection: add inspection photo button",
  "linjatarkastus: tarkastuskuvan lisäysohje": "line inspection: inspection photo hint",
  "virhe: linjatarkastuksen kohdat täyttämättä": "error: line inspection items not filled in",
  "virhe: linjatarkastuksen allekirjoitus puuttuu": "error: line inspection signature missing",
  "virhe: hyväksytyn linjatarkastuksen allekirjoitus lukittu": "error: approved line inspection signature locked",
  "virhe: allekirjoitus tyhjä": "error: signature empty",
  "opetusvideosarjan otsikko ohjeiden alla": "heading of the training video series below the guide",
  "tuontipaneelin selite: PED-luokat": "import panel description: PED categories",
  "virhe: raskas lista ylitti aikarajan (T465; T685 Toni 29.10.2026 klo 14.50: ei neuvoa rajaamisesta — haku ei rajaa laskentaa)": "error: heavy list exceeded the time limit (T465; T685: no advice to narrow the search — the search does not narrow the computation)",
  "ilmoitus: tunnuksella ei yhtään näkyvää kohdetta (T685)": "notice: the account has no visible projects (T685)",
  "tila: haku käynnissä (T685)": "state: search in progress (T685)",
  "nappi: lataa nippu uudelleen virheen jälkeen (T685)": "button: reload the batch after an error (T685)",
  "tila: haku valmis, ei rivejä (T685)": "state: search finished, no rows (T685)",
  "vihje: kohderajaus tarkastajalle ja ulkopuoliselle (T685)": "hint: project restriction for an inspector or external account (T685)",
  "syy miksi rooli ei ole valittavissa (T685)": "reason why the role cannot be selected (T685)",
};
